// @generated by protoc-gen-es v2.14.1 with parameter "target=ts,import_extension=js"
// @generated from file catalog.proto (package chessstreamlive.catalog.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { GameResult, Puzzle } from "./common_pb.js";
import { file_common } from "./common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalog.proto.
 */
export const file_catalog: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common]);

/**
 * Carried on every top-level response. Drives L0/CDN caching and honest staleness.
 *
 * @generated from message chessstreamlive.catalog.v1.ResponseMeta
 */
export type ResponseMeta = Message<"chessstreamlive.catalog.v1.ResponseMeta"> & {
  /**
   * opaque version/ETag of this document; L0 cache key
   *
   * @generated from field: string content_version = 1;
   */
  contentVersion: string;

  /**
   * age of the underlying base artifact, in seconds (published-not-synchronous staleness)
   *
   * @generated from field: uint64 base_age_seconds = 2;
   */
  baseAgeSeconds: bigint;

  /**
   * As-of markers for overlay-merged surfaces (GetTournament, ListBroadcasts),
   * making staleness and the live→cold swap observable/testable UNIFORMLY
   * rather than as per-RPC bespoke fields. 0 = not applicable / single-base
   * bootstrap. base_version = the per-namespace artifact version the durable
   * half came from; volatile_seq = the overlay apply-seq of the volatile half.
   *
   * @generated from field: uint64 base_version = 3;
   */
  baseVersion: bigint;

  /**
   * @generated from field: uint64 volatile_seq = 4;
   */
  volatileSeq: bigint;

  /**
   * Provenance of the durable half: the pipeline run id that produced the base
   * artifact this response was served from (issue #697). Empty = unknown /
   * pre-provenance artifact. Lets an operator trace a served doc back to its run.
   *
   * @generated from field: string base_run_id = 5;
   */
  baseRunId: string;

  /**
   * Edition-id mint provenance surfaced at serve time (design R5), so an operator
   * can trace a served key to the minter that produced it without opening the
   * doc. `edition_id_minter_version` echoes the served entity's IdProvenance;
   * `edition_id_minted_at_ms` is the operational first-discovery wall-clock
   * (0 = unknown / not carried) kept OUT of the hash-stable entity.
   *
   * @generated from field: string edition_id_minter_version = 6;
   */
  editionIdMinterVersion: string;

  /**
   * @generated from field: int64 edition_id_minted_at_ms = 7;
   */
  editionIdMintedAtMs: bigint;
};

/**
 * Describes the message chessstreamlive.catalog.v1.ResponseMeta.
 * Use `create(ResponseMetaSchema)` to create a new message.
 */
export const ResponseMetaSchema: GenMessage<ResponseMeta> = /*@__PURE__*/
  messageDesc(file_catalog, 0);

/**
 * How an `edition_id` was minted (design R5) — the `event_id`-style lineage that
 * travels WITH the identity. DETERMINISTIC fields only, so it is safe to embed in
 * a hash-stable entity (the wall-clock mint time lives operationally, in the
 * work-list / ResponseMeta, never here). Writer: the edition publishers; reader:
 * content-service / operators. Unset on pre-R5 / archive-minted docs.
 *
 * @generated from message chessstreamlive.catalog.v1.IdProvenance
 */
export type IdProvenance = Message<"chessstreamlive.catalog.v1.IdProvenance"> & {
  /**
   * derive_edition_id contract version (e.g. "v1")
   *
   * @generated from field: string minter_version = 1;
   */
  minterVersion: string;

  /**
   * stable upstream anchor the key was minted from
   *
   * @generated from field: string source_lichess_tour_id = 2;
   */
  sourceLichessTourId: string;

  /**
   * the exact name string fed to the minter
   *
   * @generated from field: string tour_name = 3;
   */
  tourName: string;

  /**
   * resolved year component (0 = none)
   *
   * @generated from field: int32 year = 4;
   */
  year: number;

  /**
   * "NAME" | "TOUR_CREATED_AT" | "NONE"
   *
   * @generated from field: string year_source = 5;
   */
  yearSource: string;

  /**
   * The source event names this canonical edition ABSORBED (#2098): the Lichess
   * board-group tour names ("45. Chess Olympiad Budapest 2024 | Open I", "… |
   * Open Matches 1-25") and archive edition names that fold into one event.
   * EMPTY = nothing was folded (the ordinary case). Sorted, deduplicated, and
   * deterministic, so the doc stays hash-stable.
   *
   * @generated from field: repeated string merged_source_names = 6;
   */
  mergedSourceNames: string[];

  /**
   * The upstream tour ids those sources were minted from, when known — the
   * alias set an operator/ingest resolves BY. Same ordering contract as
   * `merged_source_names`; NOT positionally paired with it (a folded archive
   * edition has a name and no tour id).
   *
   * @generated from field: repeated string merged_source_tour_ids = 7;
   */
  mergedSourceTourIds: string[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.IdProvenance.
 * Use `create(IdProvenanceSchema)` to create a new message.
 */
export const IdProvenanceSchema: GenMessage<IdProvenance> = /*@__PURE__*/
  messageDesc(file_catalog, 1);

/**
 * Live (unofficial) rating, computed between official FIDE lists (§6). NEVER
 * embedded in static docs — appears only in GetLiveStates and RatingList (both
 * volatile). One value per rating list.
 *
 * @generated from message chessstreamlive.catalog.v1.LiveRating
 */
export type LiveRating = Message<"chessstreamlive.catalog.v1.LiveRating"> & {
  /**
   * rating list: "standard" | "rapid" | "blitz"
   *
   * @generated from field: string list = 1;
   */
  list: string;

  /**
   * current live rating; absent when the player is unrated
   *
   * @generated from field: optional int32 live = 2;
   */
  live?: number | undefined;

  /**
   * signed change since the last official list (zigzag-encoded)
   *
   * @generated from field: sint32 delta = 3;
   */
  delta: number;

  /**
   * the official list rating this delta is measured from; absent if none
   *
   * @generated from field: optional int32 official_base = 4;
   */
  officialBase?: number | undefined;

  /**
   * true ⇒ surface labeled "live (unofficial)"; always true today
   *
   * @generated from field: bool unofficial = 5;
   */
  unofficial: boolean;
};

/**
 * Describes the message chessstreamlive.catalog.v1.LiveRating.
 * Use `create(LiveRatingSchema)` to create a new message.
 */
export const LiveRatingSchema: GenMessage<LiveRating> = /*@__PURE__*/
  messageDesc(file_catalog, 2);

/**
 * Chess dates are frequently partial — PGN uses "1992.??.??" / "1921.04.??".
 * Model precision EXPLICITLY: clients never parse a fuzzy string (ISO8601 /
 * LocalDate parsers crash on "??") and never render false precision (a
 * fabricated Jan-1). The build pipeline guarantees no "??" reaches the wire;
 * unknown components are simply absent here.
 *
 * @generated from message chessstreamlive.catalog.v1.PartialDate
 */
export type PartialDate = Message<"chessstreamlive.catalog.v1.PartialDate"> & {
  /**
   * 4-digit year; the coarsest granularity we ever serve (always present)
   *
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * calendar month 1–12; absent when unknown
   *
   * @generated from field: optional int32 month = 2;
   */
  month?: number | undefined;

  /**
   * day of month 1–31; absent when unknown
   *
   * @generated from field: optional int32 day = 3;
   */
  day?: number | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PartialDate.
 * Use `create(PartialDateSchema)` to create a new message.
 */
export const PartialDateSchema: GenMessage<PartialDate> = /*@__PURE__*/
  messageDesc(file_catalog, 3);

/**
 * "Simplified" identity ref — STATIC (no live rating). Lives in a response's
 * `players` dictionary; rows reference it by id. Full profile is GetPlayer.
 *
 * @generated from message chessstreamlive.catalog.v1.PlayerRef
 */
export type PlayerRef = Message<"chessstreamlive.catalog.v1.PlayerRef"> & {
  /**
   * player public id: "fide:<id>" | "p:<name-hash>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * canonical display name, e.g. "Magnus Carlsen"
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * FIDE title, e.g. "GM"/"IM"; absent if untitled/unknown
   *
   * @generated from field: optional string title = 3;
   */
  title?: string | undefined;

  /**
   * immutable R2 photo URL; MAY be empty (photo rights) → client renders initials
   *
   * @generated from field: string avatar_r2_url = 4;
   */
  avatarR2Url: string;

  /**
   * 3-letter FIDE federation code, e.g. "NOR"; empty if unknown. Durable carrier so the edition pack (D11) keeps it across incremental publishes.
   *
   * @generated from field: string federation = 5;
   */
  federation: string;

  /**
   * Same doctrine as EditionRef 7/8 — the immutable, content-addressed profile
   * BUNDLE for this player, stamped ONLY where the player is (a) the SUBJECT of
   * their own doc (the `ref` of a GetPlayer response) or (b) the TAPPABLE result
   * card (the Search PlayableItem.player arm / a feed player card). PlayerRef's
   * many other uses are dictionaries/lists — `map<string, PlayerRef> players` in
   * Feed/Edition/Series/Collection/Search/HeadToHead/Game responses, the journey
   * opponents maps, repeated refs in shelves — and stay deliberately thin
   * (invariant 3: lists never embed heavy per-row payload), so those ALWAYS leave
   * this empty. Empty = nav-only: resolve the player via GetPlayer.
   *
   * x/p/<player_id>.<hash16>.pb; empty except on the player's own doc ref + tappable player cards
   *
   * @generated from field: string profile_r2_url = 6;
   */
  profileR2Url: string;

  /**
   * ALTERNATE portrait for surfaces that want a different photo of the same
   * player than the bio page (user call, 2026-08: the tournament-journey hero
   * may not reuse the profile's portrait when a second licensed photo exists).
   * Stamped ONLY on the player's own GetPlayer doc ref, from the avatar
   * manifest's alt rows (85 of ~4k players have a second photo); every other
   * PlayerRef use — dictionaries, lists, cards — leaves it EMPTY (invariant 3),
   * and EMPTY on the doc ref simply means "no second photo": consumers fall back
   * to `avatar_r2_url`, then initials. Same immutability/licensing contract as
   * `avatar_r2_url` (field 4).
   *
   * immutable R2 URL of the alternate portrait; MAY be empty → fall back to avatar_r2_url
   *
   * @generated from field: string alt_avatar_r2_url = 7;
   */
  altAvatarR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PlayerRef.
 * Use `create(PlayerRefSchema)` to create a new message.
 */
export const PlayerRefSchema: GenMessage<PlayerRef> = /*@__PURE__*/
  messageDesc(file_catalog, 4);

/**
 * "Simplified" edition ref — STATIC. Lives in a response's `editions` dictionary
 * and as a card in PlayableItem. Full edition is GetEdition.
 *
 * @generated from message chessstreamlive.catalog.v1.EditionRef
 */
export type EditionRef = Message<"chessstreamlive.catalog.v1.EditionRef"> & {
  /**
   * edition public id: "ed:<slug>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display title, e.g. "Tata Steel Masters 2024"
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * immutable R2 cover-art URL; may be empty
   *
   * @generated from field: string cover_art_r2_url = 3;
   */
  coverArtR2Url: string;

  /**
   * edition year; absent if unknown
   *
   * @generated from field: optional int32 year = 4;
   */
  year?: number | undefined;

  /**
   * total games in the edition (ranking + UI hint)
   *
   * @generated from field: int32 game_count = 5;
   */
  gameCount: number;

  /**
   * event tier "T1".."T4" (search ranking, priority)
   *
   * @generated from field: string tier = 6;
   */
  tier: string;

  /**
   * Same pair as EditorialCard 11/12 (epic #1084 R2-only serving) — stamped ONLY
   * where the edition is the TAPPABLE RESULT CARD (the Search PlayableItem.edition
   * arm). EditionRef's other ~11 uses are dictionaries/lists (map<string,EditionRef>
   * and repeated EditionRef in Feed/Series/Edition/Player/HeadToHead/Broadcast/
   * Search responses, GetGame's edition) kept deliberately thin (invariant 3: lists
   * never embed heavy per-row payload) — those ALWAYS leave these empty; empty =
   * nav-only (classic route).
   *
   * x/exp/<edition>.<hash>.pb; empty except on tappable result cards
   *
   * @generated from field: string experience_r2_url = 7;
   */
  experienceR2Url: string;

  /**
   * x/e/<edition>.<wm>.pb; empty except on tappable result cards
   *
   * @generated from field: string pack_r2_url = 8;
   */
  packR2Url: string;

  /**
   * venue/city, e.g. "Wijk aan Zee"; empty if unknown
   *
   * @generated from field: string site = 9;
   */
  site: string;

  /**
   * host country (name or code); empty if unknown
   *
   * @generated from field: string country = 10;
   */
  country: string;

  /**
   * The owning series (persisted slug) — the edition→series BACK-HOP, the same
   * value and spelling as `Edition.series_id` (field 13) and
   * `Tournament.series_id` (field 6). Unlike the r2_url pair above this is a
   * cheap nav id, not heavy payload, so it is NOT restricted to tappable result
   * cards: any EditionRef may carry it. Empty = no owning series (a one-off
   * event) or a publisher predating the field; empty means "no hop", never
   * "look it up by title".
   *
   * @generated from field: string series_id = 11;
   */
  seriesId: string;

  /**
   * x/ed/<edition>.<hash16>.pb; empty except on tappable result cards, like fields 7/8; stamped by E4o from x/ed
   *
   * @generated from field: string edition_doc_r2_url = 12;
   */
  editionDocR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.EditionRef.
 * Use `create(EditionRefSchema)` to create a new message.
 */
export const EditionRefSchema: GenMessage<EditionRef> = /*@__PURE__*/
  messageDesc(file_catalog, 5);

/**
 * "Simplified" collection ref — STATIC. Card form of a Collection (playlist).
 *
 * @generated from message chessstreamlive.catalog.v1.CollectionRef
 */
export type CollectionRef = Message<"chessstreamlive.catalog.v1.CollectionRef"> & {
  /**
   * collection public id: "col:<slug>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display title, e.g. "Kasparov's Greatest Hits"
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * immutable R2 cover-art URL; may be empty
   *
   * @generated from field: string cover_art_r2_url = 3;
   */
  coverArtR2Url: string;

  /**
   * how this collection was assembled (drives the badge)
   *
   * @generated from field: chessstreamlive.catalog.v1.CuratorType curator = 4;
   */
  curator: CuratorType;
};

/**
 * Describes the message chessstreamlive.catalog.v1.CollectionRef.
 * Use `create(CollectionRefSchema)` to create a new message.
 */
export const CollectionRefSchema: GenMessage<CollectionRef> = /*@__PURE__*/
  messageDesc(file_catalog, 6);

/**
 * "Simplified" series ref — STATIC. Card form of a Series (the event hub that
 * owns editions). Lives in PlayableItem (search results / feed shelves). Full
 * series is GetSeries. Mirrors EditionRef so a "Tata Steel" search hit can card.
 *
 * @generated from message chessstreamlive.catalog.v1.SeriesRef
 */
export type SeriesRef = Message<"chessstreamlive.catalog.v1.SeriesRef"> & {
  /**
   * series public id (persisted slug), e.g. "tata-steel-masters" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display name, e.g. "Tata Steel Masters"
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * immutable R2 cover-art URL; may be empty
   *
   * @generated from field: string cover_art_r2_url = 3;
   */
  coverArtR2Url: string;

  /**
   * event tier "T1".."T4" (search ranking, priority)
   *
   * @generated from field: string tier = 4;
   */
  tier: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.SeriesRef.
 * Use `create(SeriesRefSchema)` to create a new message.
 */
export const SeriesRefSchema: GenMessage<SeriesRef> = /*@__PURE__*/
  messageDesc(file_catalog, 7);

/**
 * "Simplified" opening ref — STATIC. Card form of a named opening (the search
 * corpus's `'o'` etype / `ENTITY_TYPE_OPENING`). Lives in PlayableItem only:
 * there is no GetOpening RPC and no opening dictionary, because a tap routes to
 * an existing destination — the opening's curated album collection (KMP
 * `AlbumRoute.collectionIdForOpening`) or the generic opening station.
 *
 * @generated from message chessstreamlive.catalog.v1.OpeningRef
 */
export type OpeningRef = Message<"chessstreamlive.catalog.v1.OpeningRef"> & {
  /**
   * opening public id: "op:<eco>:<slug>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display name, e.g. "Sicilian Defense: Najdorf Variation"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * ECO code, e.g. "B90"; empty if unknown. Carried EXPLICITLY rather than left
   * for clients to re-parse out of `id`: the id's internal shape is a corpus
   * convention, not a wire contract, and clients never destructure server-minted
   * ids (#765). A card renders its code from this field or not at all.
   *
   * @generated from field: string eco = 3;
   */
  eco: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.OpeningRef.
 * Use `create(OpeningRefSchema)` to create a new message.
 */
export const OpeningRefSchema: GenMessage<OpeningRef> = /*@__PURE__*/
  messageDesc(file_catalog, 8);

/**
 * "Simplified" trap ref — STATIC. Card form of a named opening trap (the search
 * corpus's `'t'` etype / `ENTITY_TYPE_TRAP`). Mirrors OpeningRef.
 *
 * NOT TrapSummary: that message is the album doc-shell row for a Collection's
 * Traps tab, addressed by its owning collection and therefore carrying no id of
 * its own — a standalone search hit has nothing to route on. The two coexist by
 * design; a trap that belongs to a published album appears in both, keyed the
 * same way (`id` middle segment = album slug).
 *
 * @generated from message chessstreamlive.catalog.v1.TrapRef
 */
export type TrapRef = Message<"chessstreamlive.catalog.v1.TrapRef"> & {
  /**
   * Trap public id (§4.3): "t:<album-slug>:<trap-slug>" when the trap belongs to
   * a published album, "t:<eco>:<trap-slug>" when it does not but its ECO is
   * known, or bare "t:<trap-slug>" for a fully standalone trap.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display name, e.g. "The Siberian Trap"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * ECO code of the line the trap springs from, e.g. "B17"; empty if unknown.
   * Genuinely independent of `id` (an album-scoped trap id carries the album
   * slug in that segment, never an ECO), so this is the only carrier.
   *
   * @generated from field: string eco = 3;
   */
  eco: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.TrapRef.
 * Use `create(TrapRefSchema)` to create a new message.
 */
export const TrapRefSchema: GenMessage<TrapRef> = /*@__PURE__*/
  messageDesc(file_catalog, 9);

/**
 * The list-row form of a game (a "track"). STATIC: historical elos only; players
 * and edition referenced by id (resolve in the response `players`/`editions`
 * maps); no live rating, no review status (those arrive via GetLiveStates).
 *
 * @generated from message chessstreamlive.catalog.v1.GameTrack
 */
export type GameTrack = Message<"chessstreamlive.catalog.v1.GameTrack"> & {
  /**
   * game public id: "g:<12-hex move_hash>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * white player id → response players[white_id]
   *
   * @generated from field: string white_id = 2;
   */
  whiteId: string;

  /**
   * black player id → response players[black_id]
   *
   * @generated from field: string black_id = 3;
   */
  blackId: string;

  /**
   * outcome (shared enum; never a free string)
   *
   * @generated from field: chessstreamlive.common.v1.GameResult result = 4;
   */
  result: GameResult;

  /**
   * ECO opening code, e.g. "B90"; absent if unknown
   *
   * @generated from field: optional string eco = 5;
   */
  eco?: string | undefined;

  /**
   * human opening name (the "genre"), e.g. "Sicilian Najdorf"
   *
   * @generated from field: string opening_name = 6;
   */
  openingName: string;

  /**
   * half-move count (the "duration")
   *
   * @generated from field: int32 ply_count = 7;
   */
  plyCount: number;

  /**
   * white's rating AT GAME TIME (historical, static); absent if unknown
   *
   * @generated from field: optional int32 white_elo = 8;
   */
  whiteElo?: number | undefined;

  /**
   * black's rating at game time; absent if unknown
   *
   * @generated from field: optional int32 black_elo = 9;
   */
  blackElo?: number | undefined;

  /**
   * date played, partial-precision; NEVER a fuzzy string (see PartialDate)
   *
   * @generated from field: optional chessstreamlive.catalog.v1.PartialDate date = 10;
   */
  date?: PartialDate | undefined;

  /**
   * owning edition id → response editions[edition_id]; gives mixed-list context
   *
   * @generated from field: string edition_id = 11;
   */
  editionId: string;

  /**
   * round within the edition; absent = unknown/legacy
   *
   * @generated from field: optional uint32 round_number = 12;
   */
  roundNumber?: number | undefined;

  /**
   * Per-game eval bytes-object address (invariant 4: R2 for bytes — per-ply evals are
   * NEVER inlined on a list row). The track points at its own GameDoc; EMPTY = no evals
   * published for this game (the source PGN carried no [%eval], so no doc was minted).
   *
   * x/g/<edition_id>/<game_id>.<hash>.pb; empty = no evals
   *
   * @generated from field: string game_doc_r2_url = 13;
   */
  gameDocR2Url: string;

  /**
   * The LIVE-plane enrichment manifest for this game (D10 object,
   * `g/<game_uid>/enrichment.pb`), server-stamped by the publisher from the
   * ingest snapshot of the round this game was relayed in. It is the join
   * between a FINISHED archive row and the per-ply evals/commentary the live
   * writer already produced, so an archive reader can open the same enriched
   * board the live viewer saw.
   *
   * WIRE SHAPE: a FULL, directly dereferenceable URL — `PACK_BASE_URL` + "/" +
   * the object key — and byte-identical to the `GameUpdate.enrichment_key`
   * (broadcast_live.proto field 16) ingest stamped for this same board while
   * it was live. Dereference it VERBATIM (invariant 4 + #765): the address
   * embeds a server-side `game_uid` = H(round_id, board_id) the client cannot
   * derive, so a client that rebuilds this URL from parts is the B77
   * divergent-copy failure with a different hat.
   *
   * EMPTY means exactly one thing: no manifest is available for this game —
   * either it was never relayed live (a historical/imported game) or the
   * publisher had no join for it. It NEVER means "fetch and see"; the client
   * renders the plain archive board and offers no enrichment affordance.
   *
   * LIFECYCLE: unlike `game_doc_r2_url`, whose object is content-addressed and
   * immutable, this object is REWRITTEN IN PLACE under ETag CAS — by the
   * enrichment writer during play and by the archive projection afterwards,
   * which writes through that same writer (relay-ingest is the sole writer;
   * `is_final` is set by it at game over). The edge serves it
   * `public, max-age=5` unconditionally, final or not, so cache it by its own
   * response headers and never treat `is_final` as permission to cache forever.
   *
   * @generated from field: string enrichment_r2_url = 14;
   */
  enrichmentR2Url: string;

  /**
   * Which CORPUS lane `result` (field 4) came from, after the twin collapse
   * (#2095). Served values are ARCHIVE, BROADCAST or UNSPECIFIED only;
   * UNSPECIFIED = the row was unattributed or a producer predates the collapse,
   * NOT "no source". ARBITER is never produced — see the enum below.
   * Field 15, not 14: `enrichment_r2_url` took 14 on main (#2182 lineage) while
   * this branch was open, and a landed field number is a wire contract.
   *
   * @generated from field: chessstreamlive.catalog.v1.ResultSource result_source = 15;
   */
  resultSource: ResultSource;

  /**
   * The results the LOSING twins carried, one entry per collapsed row that
   * disagreed. Every entry is another row of OUR corpus (an archive file and the
   * broadcast feed carrying the same board differently); an outside authority's
   * result is never among them. EMPTY is the normal case and is the assertion
   * "every source that carried this game agreed"; non-empty means the served
   * `result` won a precedence contest and the alternatives are named rather than
   * dropped. Producers MUST NOT populate this with agreeing twins — a reader
   * treats any entry as "this row is disputed".
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.ResultConflict result_conflicts = 16;
   */
  resultConflicts: ResultConflict[];

  /**
   * The per-finished-game PGN bundle (design §2.1 `x/pgn/`: tag block + movetext
   * carrying `[%clk]`), byte-identical to `Game.pgn_bundle_r2_url` for the same
   * game — the publisher stamps both from ONE address. Carried on the row so a pack
   * is self-sufficient for clocks without a `GetGame` round-trip. A FULL,
   * immutable URL; dereference it verbatim. EMPTY = no bundle published (ongoing
   * game, pack plane dark, or the PUT failed) — never a placeholder.
   *
   * x/pgn/<edition_id>/<game_id>.<hash16>.pgn; empty = no bundle
   *
   * @generated from field: string pgn_bundle_r2_url = 17;
   */
  pgnBundleR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GameTrack.
 * Use `create(GameTrackSchema)` to create a new message.
 */
export const GameTrackSchema: GenMessage<GameTrack> = /*@__PURE__*/
  messageDesc(file_catalog, 10);

/**
 * One losing CORPUS row's account of a game whose twins disagreed (#2095). Never
 * an outside authority's result — see ResultSource.
 *
 * @generated from message chessstreamlive.catalog.v1.ResultConflict
 */
export type ResultConflict = Message<"chessstreamlive.catalog.v1.ResultConflict"> & {
  /**
   * which corpus lane the losing result came from (never ARBITER)
   *
   * @generated from field: chessstreamlive.catalog.v1.ResultSource source = 1;
   */
  source: ResultSource;

  /**
   * what that source recorded
   *
   * @generated from field: chessstreamlive.common.v1.GameResult result = 2;
   */
  result: GameResult;

  /**
   * The collapsed twin's own track id, so an operator can find the dropped row.
   * Empty when the losing row carried no minted id.
   *
   * @generated from field: string track_id = 3;
   */
  trackId: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.ResultConflict.
 * Use `create(ResultConflictSchema)` to create a new message.
 */
export const ResultConflictSchema: GenMessage<ResultConflict> = /*@__PURE__*/
  messageDesc(file_catalog, 11);

/**
 * @generated from message chessstreamlive.catalog.v1.GetFeedRequest
 */
export type GetFeedRequest = Message<"chessstreamlive.catalog.v1.GetFeedRequest"> & {
  /**
   * feed id: "f:home_default" | "f:event_wc2026" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * opaque cursor from a prior Feed.next_page_token; empty = first page
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetFeedRequest.
 * Use `create(GetFeedRequestSchema)` to create a new message.
 */
export const GetFeedRequestSchema: GenMessage<GetFeedRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 12);

/**
 * @generated from message chessstreamlive.catalog.v1.Feed
 */
export type Feed = Message<"chessstreamlive.catalog.v1.Feed"> & {
  /**
   * echoes the requested feed id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ordered carousels, top-to-bottom
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.Shelf shelves = 2;
   */
  shelves: Shelf[];

  /**
   * cursor for the next page of shelves; empty = last page
   *
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 4;
   */
  meta?: ResponseMeta | undefined;

  /**
   * dictionary for GameTrack white_id/black_id refs
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 5;
   */
  players: { [key: string]: PlayerRef };

  /**
   * dictionary for GameTrack edition_id refs (games span editions)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 6;
   */
  editions: { [key: string]: EditionRef };

  /**
   * structured feed modules (PR #520 B2). Writer: feed producer; reader: app
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.FeedModule modules = 7;
   */
  modules: FeedModule[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.Feed.
 * Use `create(FeedSchema)` to create a new message.
 */
export const FeedSchema: GenMessage<Feed> = /*@__PURE__*/
  messageDesc(file_catalog, 13);

/**
 * @generated from message chessstreamlive.catalog.v1.Shelf
 */
export type Shelf = Message<"chessstreamlive.catalog.v1.Shelf"> & {
  /**
   * shelf heading, e.g. "Legendary Rivalries"
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * rationale chip; population-level here ("Trending at the WC") — per-user text is set by the personalized layer
   *
   * @generated from field: string context_tag = 2;
   */
  contextTag: string;

  /**
   * ordered cards in this carousel
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.PlayableItem items = 3;
   */
  items: PlayableItem[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.Shelf.
 * Use `create(ShelfSchema)` to create a new message.
 */
export const ShelfSchema: GenMessage<Shelf> = /*@__PURE__*/
  messageDesc(file_catalog, 14);

/**
 * Polymorphic card. Clients MUST skip unknown arms (proto/README rule 4).
 * Cards (collection/edition/player) embed inline refs — no dedup pressure;
 * only GameTrack uses the dictionaries (games densely repeat players/editions).
 *
 * @generated from message chessstreamlive.catalog.v1.PlayableItem
 */
export type PlayableItem = Message<"chessstreamlive.catalog.v1.PlayableItem"> & {
  /**
   * @generated from oneof chessstreamlive.catalog.v1.PlayableItem.item
   */
  item: {
    /**
     * a single game ("track")
     *
     * @generated from field: chessstreamlive.catalog.v1.GameTrack game = 1;
     */
    value: GameTrack;
    case: "game";
  } | {
    /**
     * a playlist card
     *
     * @generated from field: chessstreamlive.catalog.v1.CollectionRef collection = 2;
     */
    value: CollectionRef;
    case: "collection";
  } | {
    /**
     * an event/album card
     *
     * @generated from field: chessstreamlive.catalog.v1.EditionRef edition = 3;
     */
    value: EditionRef;
    case: "edition";
  } | {
    /**
     * a player/artist card
     *
     * @generated from field: chessstreamlive.catalog.v1.PlayerRef player = 4;
     */
    value: PlayerRef;
    case: "player";
  } | {
    /**
     * an event-series card (the hub of editions)
     *
     * @generated from field: chessstreamlive.catalog.v1.SeriesRef series = 5;
     */
    value: SeriesRef;
    case: "series";
  } | {
    /**
     * hand-crafted editorial card (Home hero / today-in-chess)
     *
     * @generated from field: chessstreamlive.catalog.v1.EditorialCard editorial = 6;
     */
    value: EditorialCard;
    case: "editorial";
  } | {
    /**
     * Search-result cards for the two entity types the wire already accepts in
     * `SearchRequest.types` (#1436). Contract-only: no indexer writes
     * opening/trap `search_entity` rows yet, so nothing emits these arms — they
     * exist so that a served opening/trap result is REPRESENTABLE the day one
     * does. The `EntityKind` registry's `serverIndexed=false` stops the client
     * asking for them meanwhile; `vocab.tsv`'s `playable_item_arm` column welds
     * that flag to these arms so it cannot be flipped ahead of them.
     *
     * a named-opening card
     *
     * @generated from field: chessstreamlive.catalog.v1.OpeningRef opening = 7;
     */
    value: OpeningRef;
    case: "opening";
  } | {
    /**
     * an opening-trap card
     *
     * @generated from field: chessstreamlive.catalog.v1.TrapRef trap = 8;
     */
    value: TrapRef;
    case: "trap";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chessstreamlive.catalog.v1.PlayableItem.
 * Use `create(PlayableItemSchema)` to create a new message.
 */
export const PlayableItemSchema: GenMessage<PlayableItem> = /*@__PURE__*/
  messageDesc(file_catalog, 15);

/**
 * Hand-crafted editorial card used for the home hero carousel and "Today in Chess".
 * V1: art stays unpopulated; clients render the FEN locally.
 *
 * @generated from message chessstreamlive.catalog.v1.EditorialCard
 */
export type EditorialCard = Message<"chessstreamlive.catalog.v1.EditorialCard"> & {
  /**
   * small text above title, e.g. "Featured"
   *
   * @generated from field: string eyebrow = 1;
   */
  eyebrow: string;

  /**
   * main heading
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * secondary text/prose
   *
   * @generated from field: string subtitle = 3;
   */
  subtitle: string;

  /**
   * seed for generated background gradient/tint
   *
   * @generated from field: string tint_seed = 4;
   */
  tintSeed: string;

  /**
   * optional badge text, e.g. "Exclusive"
   *
   * @generated from field: string badge = 5;
   */
  badge: string;

  /**
   * board position to render (if applicable)
   *
   * @generated from field: string fen = 6;
   */
  fen: string;

  /**
   * true if the board should be viewed from Black's side
   *
   * @generated from field: bool flipped = 7;
   */
  flipped: boolean;

  /**
   * e.g. "e4"; square to highlight on the board
   *
   * @generated from field: string highlight_square = 8;
   */
  highlightSquare: string;

  /**
   * deep-link route on tap, e.g. "/edition/ed:slug"
   *
   * @generated from field: string cta_route = 9;
   */
  ctaRoute: string;

  /**
   * optional rich artwork; unpopulated in v1
   *
   * @generated from field: string artwork_r2_url = 10;
   */
  artworkR2Url: string;

  /**
   * Finished/upcoming tournament cards: the R2 objects the destination renders
   * from (epic #1084 R2-only serving). BOTH EMPTY ⇒ nav-only card (the client
   * falls back to the live GetTournament path). experience set + pack empty ⇒
   * UPCOMING preview shell (the pack does not exist until the event finishes).
   *
   * x/exp/<edition>.<hash>.pb (experiencex.TournamentExperience)
   *
   * @generated from field: string experience_r2_url = 11;
   */
  experienceR2Url: string;

  /**
   * x/e/<edition>.<wm>.pb (mirrors Edition.bulk_pack_r2_url = 9)
   *
   * @generated from field: string pack_r2_url = 12;
   */
  packR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.EditorialCard.
 * Use `create(EditorialCardSchema)` to create a new message.
 */
export const EditorialCardSchema: GenMessage<EditorialCard> = /*@__PURE__*/
  messageDesc(file_catalog, 16);

/**
 * @generated from message chessstreamlive.catalog.v1.GetCollectionRequest
 */
export type GetCollectionRequest = Message<"chessstreamlive.catalog.v1.GetCollectionRequest"> & {
  /**
   * collection id "col:<slug>"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * opaque cursor; empty = first page
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * requested tracks per page; 0 = server default
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetCollectionRequest.
 * Use `create(GetCollectionRequestSchema)` to create a new message.
 */
export const GetCollectionRequestSchema: GenMessage<GetCollectionRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 17);

/**
 * @generated from message chessstreamlive.catalog.v1.Collection
 */
export type Collection = Message<"chessstreamlive.catalog.v1.Collection"> & {
  /**
   * echoes the collection id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display title
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * prose blurb shown on the playlist header
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * immutable R2 cover-art URL; may be empty
   *
   * @generated from field: string cover_art_r2_url = 4;
   */
  coverArtR2Url: string;

  /**
   * how it was assembled (badge)
   *
   * @generated from field: chessstreamlive.catalog.v1.CuratorType curator = 5;
   */
  curator: CuratorType;

  /**
   * for ALGORITHMIC: ranker version, A/B via flags-as-content; absent for EDITORIAL
   *
   * @generated from field: optional string model_version = 6;
   */
  modelVersion?: string | undefined;

  /**
   * page of games in playlist order
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.GameTrack tracks = 7;
   */
  tracks: GameTrack[];

  /**
   * cursor for the next page; empty = last
   *
   * @generated from field: string next_page_token = 8;
   */
  nextPageToken: string;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 9;
   */
  meta?: ResponseMeta | undefined;

  /**
   * dictionary for track player refs
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 10;
   */
  players: { [key: string]: PlayerRef };

  /**
   * dictionary for track edition refs (mixed playlist → many editions)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 11;
   */
  editions: { [key: string]: EditionRef };

  /**
   * ECO code for an opening/gambit collection, e.g. "C42"; empty otherwise
   *
   * @generated from field: string eco = 12;
   */
  eco: string;

  /**
   * Lichess opening tag to source this collection's puzzles; empty otherwise
   *
   * @generated from field: string opening_tag = 13;
   */
  openingTag: string;

  /**
   * immutable album pack (mirrors Edition.bulk_pack_r2_url = 9); empty for non-album collections
   *
   * @generated from field: string album_pack_r2_url = 14;
   */
  albumPackR2Url: string;

  /**
   * "tracks": named sub-lines grouping model games; empty for non-album collections
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.VariationGroup variation_groups = 15;
   */
  variationGroups: VariationGroup[];

  /**
   * curated, engine-verified named traps for the Traps tab. The doc-shell carries name/blurb/side/swing so the tab renders before the pack hydrates; the verified move LINES live in the album pack (design §3.5). Empty for non-album collections.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.TrapSummary traps = 16;
   */
  traps: TrapSummary[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.Collection.
 * Use `create(CollectionSchema)` to create a new message.
 */
export const CollectionSchema: GenMessage<Collection> = /*@__PURE__*/
  messageDesc(file_catalog, 18);

/**
 * A curated, Stockfish-verified named trap of an opening album, in doc-shell
 * form: enough to render the Traps tab (name + lore + which side springs it +
 * the verified swing) before the album pack — which carries the replayable move
 * line — is fetched. Mirrors the album pack's TrapLine minus the move bytes.
 *
 * @generated from message chessstreamlive.catalog.v1.TrapSummary
 */
export type TrapSummary = Message<"chessstreamlive.catalog.v1.TrapSummary"> & {
  /**
   * display name, e.g. "The Siberian Trap"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * editorial lore for the trap
   *
   * @generated from field: string blurb = 2;
   */
  blurb: string;

  /**
   * 0=unspecified, 1=White springs the trap, 2=Black
   *
   * @generated from field: uint32 trapping_side = 3;
   */
  trappingSide: number;

  /**
   * Stockfish-verified swing for the trapping side (mate ⇒ ±(10000−10N) band)
   *
   * @generated from field: int32 eval_swing_cp = 4;
   */
  evalSwingCp: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.TrapSummary.
 * Use `create(TrapSummarySchema)` to create a new message.
 */
export const TrapSummarySchema: GenMessage<TrapSummary> = /*@__PURE__*/
  messageDesc(file_catalog, 19);

/**
 * Named sub-line ("track") of an opening album: a group of model games sharing a
 * variation, rendered as a labelled section on the collection page. The heavy
 * per-variation W/D/L lives in the album pack; the doc-shell carries labels + refs
 * so the section renders before the pack hydrates.
 *
 * @generated from message chessstreamlive.catalog.v1.VariationGroup
 */
export type VariationGroup = Message<"chessstreamlive.catalog.v1.VariationGroup"> & {
  /**
   * display label, e.g. "Fully Accepted"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * narrowest ECO for the group; may equal Collection.eco
   *
   * @generated from field: string eco = 2;
   */
  eco: string;

  /**
   * refs into Collection.tracks (GameTrack.id)
   *
   * @generated from field: repeated string game_ids = 3;
   */
  gameIds: string[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.VariationGroup.
 * Use `create(VariationGroupSchema)` to create a new message.
 */
export const VariationGroupSchema: GenMessage<VariationGroup> = /*@__PURE__*/
  messageDesc(file_catalog, 20);

/**
 * @generated from message chessstreamlive.catalog.v1.GetPositionExplorerRequest
 */
export type GetPositionExplorerRequest = Message<"chessstreamlive.catalog.v1.GetPositionExplorerRequest"> & {
  /**
   * owning album ("col:<slug>"); reserved for future per-album pruned stores. Empty = whole-corpus store.
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * SAN moves from the start position, e.g. ["e4","c5","Nf3"]; empty = start position
   *
   * @generated from field: repeated string san_path = 2;
   */
  sanPath: string[];

  /**
   * "all" (default) | "elite" (both Elos ≥ 2500)
   *
   * @generated from field: string variant = 3;
   */
  variant: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetPositionExplorerRequest.
 * Use `create(GetPositionExplorerRequestSchema)` to create a new message.
 */
export const GetPositionExplorerRequestSchema: GenMessage<GetPositionExplorerRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 21);

/**
 * @generated from message chessstreamlive.catalog.v1.GetPositionExplorerResponse
 */
export type GetPositionExplorerResponse = Message<"chessstreamlive.catalog.v1.GetPositionExplorerResponse"> & {
  /**
   * FEN of the reached position
   *
   * @generated from field: string fen = 1;
   */
  fen: string;

  /**
   * half-moves from the start (== san_path length)
   *
   * @generated from field: uint32 ply = 2;
   */
  ply: number;

  /**
   * games that reached this position (0 when novel)
   *
   * @generated from field: uint32 position_games = 3;
   */
  positionGames: number;

  /**
   * true ⇒ this position never occurred in the corpus
   *
   * @generated from field: bool is_novel = 4;
   */
  isNovel: boolean;

  /**
   * moves played from here, ranked by game count (descending)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.MoveWdl continuations = 5;
   */
  continuations: MoveWdl[];

  /**
   * EVERY legal move here (incl. novelties), so the board plays past the corpus
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.LegalMove legal = 6;
   */
  legal: LegalMove[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetPositionExplorerResponse.
 * Use `create(GetPositionExplorerResponseSchema)` to create a new message.
 */
export const GetPositionExplorerResponseSchema: GenMessage<GetPositionExplorerResponse> = /*@__PURE__*/
  messageDesc(file_catalog, 22);

/**
 * One continuation move with its W/D/L over the corpus. W+D+L == games exactly
 * (result-unknown games are excluded from the store — the same invariant the
 * per-variation W/D/L holds).
 *
 * @generated from message chessstreamlive.catalog.v1.MoveWdl
 */
export type MoveWdl = Message<"chessstreamlive.catalog.v1.MoveWdl"> & {
  /**
   * move in SAN, e.g. "Nf3"
   *
   * @generated from field: string san = 1;
   */
  san: string;

  /**
   * move in UCI, e.g. "g1f3"
   *
   * @generated from field: string uci = 2;
   */
  uci: string;

  /**
   * total games playing this move (white + draws + black)
   *
   * @generated from field: uint64 games = 3;
   */
  games: bigint;

  /**
   * games White went on to win
   *
   * @generated from field: uint32 white = 4;
   */
  white: number;

  /**
   * games drawn
   *
   * @generated from field: uint32 draws = 5;
   */
  draws: number;

  /**
   * games Black went on to win
   *
   * @generated from field: uint32 black = 6;
   */
  black: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.MoveWdl.
 * Use `create(MoveWdlSchema)` to create a new message.
 */
export const MoveWdlSchema: GenMessage<MoveWdl> = /*@__PURE__*/
  messageDesc(file_catalog, 23);

/**
 * A legal move in the reached position. The server generates these so the client
 * has no chess logic; `known` marks whether the move has corpus data (false = a
 * novelty the board can still play into).
 *
 * @generated from message chessstreamlive.catalog.v1.LegalMove
 */
export type LegalMove = Message<"chessstreamlive.catalog.v1.LegalMove"> & {
  /**
   * origin square, e.g. "g1" (king's square for castling)
   *
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * destination square, e.g. "f3" (king's true destination for castling)
   *
   * @generated from field: string to = 2;
   */
  to: string;

  /**
   * move in SAN
   *
   * @generated from field: string san = 3;
   */
  san: string;

  /**
   * promotion piece letter ("q"/"r"/"b"/"n"); empty when not a promotion
   *
   * @generated from field: string promo = 4;
   */
  promo: string;

  /**
   * true ⇒ this move appears in the corpus (has a MoveWdl row)
   *
   * @generated from field: bool known = 5;
   */
  known: boolean;
};

/**
 * Describes the message chessstreamlive.catalog.v1.LegalMove.
 * Use `create(LegalMoveSchema)` to create a new message.
 */
export const LegalMoveSchema: GenMessage<LegalMove> = /*@__PURE__*/
  messageDesc(file_catalog, 24);

/**
 * @generated from message chessstreamlive.catalog.v1.GetSeriesRequest
 */
export type GetSeriesRequest = Message<"chessstreamlive.catalog.v1.GetSeriesRequest"> & {
  /**
   * series id (persisted slug), e.g. "tata-steel-masters"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Pagination over `Series.editions`. Today the builder keeps only the 24
   * most recent editions per series (`pipeline/aggregate.rs:28`,
   * `SERIES_EDITIONS`) and the deeper history is dropped SILENTLY — the
   * response carries no signal that anything was cut, so a long-running series
   * (Tata Steel, Hastings, the Olympiad) simply looks 24 editions old. These
   * two fields are the contract that lets the server return the whole history a
   * page at a time instead.
   *
   * requested editions per page; 0 = server default
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * opaque cursor; empty = first page
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetSeriesRequest.
 * Use `create(GetSeriesRequestSchema)` to create a new message.
 */
export const GetSeriesRequestSchema: GenMessage<GetSeriesRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 25);

/**
 * @generated from message chessstreamlive.catalog.v1.Series
 */
export type Series = Message<"chessstreamlive.catalog.v1.Series"> & {
  /**
   * echoes the series id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display name, e.g. "Tata Steel Masters"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * event tier "T1".."T4"
   *
   * @generated from field: string tier = 3;
   */
  tier: string;

  /**
   * ONE PAGE of this series' editions (recent-first); see next_page_token
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.EditionRef editions = 4;
   */
  editions: EditionRef[];

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 5;
   */
  meta?: ResponseMeta | undefined;

  /**
   * The series' YEAR SPAN, derived build-side as min/max over the editions with
   * a KNOWN year — the whole series, not just the page in `editions`. It is what
   * makes the `SearchRequest.year` facet uniform: a series carries no single
   * year, so it matches a year filter by containment,
   * `first_year <= year <= last_year`.
   *
   * Absent means the series carries NOTHING on the year axis (every edition's
   * year is unknown), which under the facet plane's fail-closed rule EXCLUDES it
   * from any year-filtered query — absent is not "any year". The two fields are
   * set together or not at all; a single-edition series has
   * `first_year == last_year`.
   *
   * @generated from field: optional int32 first_year = 6;
   */
  firstYear?: number | undefined;

  /**
   * @generated from field: optional int32 last_year = 7;
   */
  lastYear?: number | undefined;

  /**
   * cursor for the next page of editions; empty = last
   *
   * @generated from field: string next_page_token = 8;
   */
  nextPageToken: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Series.
 * Use `create(SeriesSchema)` to create a new message.
 */
export const SeriesSchema: GenMessage<Series> = /*@__PURE__*/
  messageDesc(file_catalog, 26);

/**
 * @generated from message chessstreamlive.catalog.v1.GetEditionRequest
 */
export type GetEditionRequest = Message<"chessstreamlive.catalog.v1.GetEditionRequest"> & {
  /**
   * edition id "ed:<slug>"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * opaque cursor over the games list; empty = first page
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * requested games per page; 0 = server default
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetEditionRequest.
 * Use `create(GetEditionRequestSchema)` to create a new message.
 */
export const GetEditionRequestSchema: GenMessage<GetEditionRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 27);

/**
 * @generated from message chessstreamlive.catalog.v1.Edition
 */
export type Edition = Message<"chessstreamlive.catalog.v1.Edition"> & {
  /**
   * echoes the edition id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display title
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * edition year; absent if unknown
   *
   * @generated from field: optional int32 year = 3;
   */
  year?: number | undefined;

  /**
   * venue/city, e.g. "Wijk aan Zee"
   *
   * @generated from field: string site = 4;
   */
  site: string;

  /**
   * host country (name or code)
   *
   * @generated from field: string country = 5;
   */
  country: string;

  /**
   * crosstable rows (rank/score), full set (bounded by participant count)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.Standing standings = 6;
   */
  standings: Standing[];

  /**
   * PAGINATED games list — 4,415-game worst case (§8.2)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.GameTrack tracks = 7;
   */
  tracks: GameTrack[];

  /**
   * cursor for the next page of games; empty = last
   *
   * @generated from field: string next_page_token = 8;
   */
  nextPageToken: string;

  /**
   * immutable R2 pack: the whole edition for offline ("airplane mode")
   *
   * @generated from field: string bulk_pack_r2_url = 9;
   */
  bulkPackR2Url: string;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 10;
   */
  meta?: ResponseMeta | undefined;

  /**
   * dictionary sized to PARTICIPANTS (not games); resolves track + standing refs
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 11;
   */
  players: { [key: string]: PlayerRef };

  /**
   * (all tracks share THIS edition — their edition_id resolves to `id`; no editions map needed.)
   *
   * tournament format, e.g. "8-player double round-robin · Classical"; empty if unknown
   *
   * @generated from field: string format = 12;
   */
  format: string;

  /**
   * The owning series (persisted slug, e.g. "tata-steel-masters") — the
   * edition→series BACK-HOP, the inverse of `Series.editions`. Same value and
   * same spelling as `Tournament.series_id` (field 6) on the sibling doc whose
   * edition_id == this id. Empty when the edition belongs to no series (a
   * one-off event) or when the publisher predates this field; empty means "no
   * hop", never "look it up by title".
   *
   * @generated from field: string series_id = 13;
   */
  seriesId: string;

  /**
   * value Search stamps on EditionRef.experience_r2_url = 7; stamped by E4o
   *
   * @generated from field: string experience_r2_url = 14;
   */
  experienceR2Url: string;

  /**
   * FIDE rating category of this edition's games, in the vocabulary of
   * `relay_common::tier::normalize_format`: "classical" | "rapid" | "blitz"
   * (the Lichess `tour.info.fideTC` the drain bundle carries as `edition.json`
   * `speed`; "standard" is spelled "classical"). NOT `format` (field 12), which is
   * the pairing format. ABSENT = unknown — never guessed from the title. A reader
   * that needs a category (the live-rating fold) treats absent as "not this one".
   * Paged editions carry it on every `edition_page_doc` header.
   *
   * (Edition mint provenance is carried on the sibling Tournament doc, whose
   * edition_id == this id — see Tournament.id_provenance, design R5.)
   *
   * @generated from field: optional string speed = 15;
   */
  speed?: string | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Edition.
 * Use `create(EditionSchema)` to create a new message.
 */
export const EditionSchema: GenMessage<Edition> = /*@__PURE__*/
  messageDesc(file_catalog, 28);

/**
 * One labeled tie-break column of a standings table.
 *
 * @generated from message chessstreamlive.catalog.v1.TieBreak
 */
export type TieBreak = Message<"chessstreamlive.catalog.v1.TieBreak"> & {
  /**
   * stable column label: "SB", "Buchholz", "BuchholzCut1", "DirectEncounter", "Wins"
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: float value = 2;
   */
  value: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.TieBreak.
 * Use `create(TieBreakSchema)` to create a new message.
 */
export const TieBreakSchema: GenMessage<TieBreak> = /*@__PURE__*/
  messageDesc(file_catalog, 29);

/**
 * @generated from message chessstreamlive.catalog.v1.Standing
 */
export type Standing = Message<"chessstreamlive.catalog.v1.Standing"> & {
  /**
   * participant id → Edition.players[player_id]
   *
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * Final placement (1 = first), SERVER-ASSIGNED and total: the client renders
   * the order it is given and never re-derives one from `score`. Rows share a
   * rank when `score` and EVERY listed tie-break column agree; the order among
   * equal rows is then the engine's documented final key — the participant's
   * stable identity key (`standings_team::player_key`: the source's own id, else
   * `fide:<id>`, else the normalised name), ascending. That last key exists only
   * to make the emitted order deterministic across runs; it is NOT a sporting
   * rule, and the organiser's own order within a tie is undisclosed on every
   * event measured so far (the official GCL table orders two 12-point players
   * one way and Lichess the other, with nothing in either feed explaining it).
   *
   * @generated from field: int32 rank = 2;
   */
  rank: number;

  /**
   * points scored (e.g. 8.5)
   *
   * @generated from field: float score = 3;
   */
  score: number;

  /**
   * primary tie-break value; == tiebreaks[0].value when tiebreaks present
   *
   * @generated from field: optional float tie_break = 4;
   */
  tieBreak?: number | undefined;

  /**
   * ordered tie-break columns, in the order used for ranking
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.TieBreak tiebreaks = 5;
   */
  tiebreaks: TieBreak[];

  /**
   * The player's TEAM in a team event, canonical spelling (the same string
   * `TeamStanding.team` carries, so the two planes join by equality). Absent on
   * an individual event, and absent — never guessed — when the feed published no
   * team tag for this player. NOT a federation: `PlayerRef.federation` is a
   * 3-letter country code derived from `[WhiteTeam]` only when the tag LOOKS
   * like one, and a club/franchise event fills this field while leaving that one
   * empty.
   *
   * @generated from field: optional string team = 6;
   */
  team?: string | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Standing.
 * Use `create(StandingSchema)` to create a new message.
 */
export const StandingSchema: GenMessage<Standing> = /*@__PURE__*/
  messageDesc(file_catalog, 30);

/**
 * One ranked TEAM row of a team event's table. Sibling of `Standing`: the two
 * planes of the same table, never a replacement for it — `rows` stays the
 * individual plane (which a team event also publishes, per board).
 *
 * Every column an organiser publishes is here, because a reader compares whole
 * rows: match points and game points are SEPARATE quantities (the GCL pays 3
 * match points for a match win and, on the board plane, 3 for a win with White
 * and 4 with Black), so a single `score` cannot express this table.
 *
 * @generated from message chessstreamlive.catalog.v1.TeamStanding
 */
export type TeamStanding = Message<"chessstreamlive.catalog.v1.TeamStanding"> & {
  /**
   * canonical team name, after the edition's alias folding; joins Standing.team
   *
   * @generated from field: string team = 1;
   */
  team: string;

  /**
   * Final placement (1 = first), SERVER-ASSIGNED and total, under the SAME rule
   * `Standing.rank` documents: rows share a rank when every listed tie-break
   * column agrees, and the order among equal rows is the engine's documented
   * final key — here the canonical team name ascending. The client renders the
   * order it is given; it never sorts by `match_points` or `game_points` itself
   * (a board-points-first sort ranks the GCL 2026 last-placed team 4th of 6).
   * `int32`, the SAME type `Standing.rank` carries: one quantity, one type, so
   * no reader and no server mapping has to clamp a rank between the two planes.
   *
   * @generated from field: int32 rank = 2;
   */
  rank: number;

  /**
   * primary ranking key of every team fixture (GCL: 3/1/0)
   *
   * @generated from field: float match_points = 3;
   */
  matchPoints: number;

  /**
   * board points summed over the team's boards — NOT a win count
   *
   * @generated from field: float game_points = 4;
   */
  gamePoints: number;

  /**
   * matches counted in the +/=/− columns (a bye is excluded unless the fixture counts it)
   *
   * @generated from field: uint32 played = 5;
   */
  played: number;

  /**
   * match wins (decided on board points within the match)
   *
   * @generated from field: uint32 wins = 6;
   */
  wins: number;

  /**
   * @generated from field: uint32 draws = 7;
   */
  draws: number;

  /**
   * @generated from field: uint32 losses = 8;
   */
  losses: number;

  /**
   * The ordered tie-break battery, in the exact order the ranking consulted it —
   * same labels and same message as the individual plane.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.TieBreak tiebreaks = 9;
   */
  tiebreaks: TieBreak[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.TeamStanding.
 * Use `create(TeamStandingSchema)` to create a new message.
 */
export const TeamStandingSchema: GenMessage<TeamStanding> = /*@__PURE__*/
  messageDesc(file_catalog, 31);

/**
 * @generated from message chessstreamlive.catalog.v1.ListBroadcastsRequest
 */
export type ListBroadcastsRequest = Message<"chessstreamlive.catalog.v1.ListBroadcastsRequest"> & {
  /**
   * recently-finished window (0 = server default); bounds the body
   *
   * @generated from field: int32 finished_window_secs = 1;
   */
  finishedWindowSecs: number;

  /**
   * cursor over recently_finished (active/upcoming are unbounded-small)
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * requested recently_finished entries per page; 0 = server default (AIP-158)
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.ListBroadcastsRequest.
 * Use `create(ListBroadcastsRequestSchema)` to create a new message.
 */
export const ListBroadcastsRequestSchema: GenMessage<ListBroadcastsRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 32);

/**
 * State is encoded by BUCKET MEMBERSHIP (active/upcoming/recently_finished), NOT
 * a per-entry enum — so a round can never be filed as e.g. live-but-scheduled.
 * The producer's live_state signal lives on the write side (overlay_push.v1
 * RoundUpsert); the server buckets by it here. (#278 D1.)
 *
 * @generated from message chessstreamlive.catalog.v1.BroadcastList
 */
export type BroadcastList = Message<"chessstreamlive.catalog.v1.BroadcastList"> & {
  /**
   * STREAMING — watchable now
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.BroadcastEntry active = 1;
   */
  active: BroadcastEntry[];

  /**
   * SCHEDULED — starts_at ascending
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.BroadcastEntry upcoming = 2;
   */
  upcoming: BroadcastEntry[];

  /**
   * FINISHED within the window — newest first
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.BroadcastEntry recently_finished = 3;
   */
  recentlyFinished: BroadcastEntry[];

  /**
   * cursor for recently_finished
   *
   * @generated from field: string next_page_token = 4;
   */
  nextPageToken: string;

  /**
   * version + staleness (SHORT-TTL: this body IS live data)
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 5;
   */
  meta?: ResponseMeta | undefined;

  /**
   * durable edition refs for finished rounds (by edition_id)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 6;
   */
  editions: { [key: string]: EditionRef };

  /**
   * The "Heating Up" hero: the hottest live boards ACROSS all active rounds,
   * tension-descending. Cross-cutting by design — it is not a per-entry field,
   * because the hero ranks boards, not rounds. EMPTY (the only absence signal:
   * feature off, TTL-expired push, or nothing above the heat threshold) ⇒ the
   * client HIDES the section entirely; there is no placeholder state. (#1279)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.HotBoardEntry hot_boards = 7;
   */
  hotBoards: HotBoardEntry[];

  /**
   * false until this instance has applied any calendar (push or object); clients render "calendar unavailable", not "no rounds"
   *
   * @generated from field: bool overlay_seeded = 8;
   */
  overlaySeeded: boolean;

  /**
   * now - OverlayPush.generated_at_ms of the applied calendar. ABSENT (field
   * presence, not 0) when the age is unknown: nothing applied yet, or a legacy
   * push that carried no assembly time. 0 would be a lie — indistinguishable
   * from a calendar generated this instant, which is the opposite conclusion.
   *
   * @generated from field: optional uint64 calendar_age_seconds = 9;
   */
  calendarAgeSeconds?: bigint | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.BroadcastList.
 * Use `create(BroadcastListSchema)` to create a new message.
 */
export const BroadcastListSchema: GenMessage<BroadcastList> = /*@__PURE__*/
  messageDesc(file_catalog, 33);

/**
 * @generated from message chessstreamlive.catalog.v1.BroadcastEntry
 */
export type BroadcastEntry = Message<"chessstreamlive.catalog.v1.BroadcastEntry"> & {
  /**
   * Subscribe(round_id) target (matches broadcast_live GameUpdate.round_id)
   *
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * Lichess broadcast tournament id
   *
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * slug for deep-linking
   *
   * @generated from field: string tour_slug = 3;
   */
  tourSlug: string;

  /**
   * "Tata Steel Masters — Round 11"
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * "Round 11"
   *
   * @generated from field: string round_name = 5;
   */
  roundName: string;

  /**
   * event tier "T1".."T4" (matches EditionRef/Series.tier); empty if unknown
   *
   * @generated from field: string tier = 6;
   */
  tier: string;

  /**
   * epoch ms UTC; absent for startsAfterPrevious rounds
   *
   * @generated from field: optional int64 starts_at_ms = 7;
   */
  startsAtMs?: bigint | undefined;

  /**
   * "ed:<slug>" → BroadcastList.editions[edition_id]; present once archived
   *
   * @generated from field: optional string edition_id = 8;
   */
  editionId?: string | undefined;

  /**
   * boards in the round (UI hint); absent if unknown
   *
   * @generated from field: optional int32 board_count = 9;
   */
  boardCount?: number | undefined;

  /**
   * cover image; may be empty
   *
   * @generated from field: string image_url = 10;
   */
  imageUrl: string;

  /**
   * Lichess info.fideTC: "standard"|"rapid"|"blitz"; the
   *
   * @generated from field: optional string fide_tc = 11;
   */
  fideTc?: string | undefined;

  /**
   * authoritative time-format label (~100% populated upstream).
   * Absent only for non-Lichess/legacy entries. Consumers map
   * "standard"→Classical. Passed through from TournamentInfo.fide_tc.
   *
   * Lichess info.players: comma-separated notable participants,
   *
   * @generated from field: optional string players = 12;
   */
  players?: string | undefined;

  /**
   * Lichess tour.name verbatim — the event's name without the round suffix
   * that `title` carries; empty only for a legacy producer.
   *
   * @generated from field: string tour_name = 13;
   */
  tourName: string;

  /**
   * Lichess tour.dates[0] (epoch ms UTC); absent when the organiser set none
   *
   * @generated from field: optional int64 tour_starts_at_ms = 14;
   */
  tourStartsAtMs?: bigint | undefined;

  /**
   * Lichess tour.dates[1]; absent for a one-date tour
   *
   * @generated from field: optional int64 tour_ends_at_ms = 15;
   */
  tourEndsAtMs?: bigint | undefined;

  /**
   * Lichess broadcast-group id when the tour belongs to a group (8 chars); empty
   * when it does not, or when the producer predates this field. Resolved by
   * relay-control from the tour detail (#2459) — the key a client groups tours
   * into one EVENT by (the Olympiad's nine sections are one card).
   *
   * @generated from field: string group_id = 16;
   */
  groupId: string;

  /**
   * Lichess group name verbatim (the calendar feed carries it on every tour of a
   * group); empty when the tour is not in a group.
   *
   * NB: no live_state — state is the BroadcastList bucket (see above).
   *
   * @generated from field: string group_name = 17;
   */
  groupName: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.BroadcastEntry.
 * Use `create(BroadcastEntrySchema)` to create a new message.
 */
export const BroadcastEntrySchema: GenMessage<BroadcastEntry> = /*@__PURE__*/
  messageDesc(file_catalog, 34);

/**
 * One reason chip under a hot board's headline.
 *
 * @generated from message chessstreamlive.catalog.v1.HotChip
 */
export type HotChip = Message<"chessstreamlive.catalog.v1.HotChip"> & {
  /**
   * icon/tint selector — see the enum
   *
   * @generated from field: chessstreamlive.catalog.v1.HotChipKind kind = 1;
   */
  kind: HotChipKind;

  /**
   * rendered text, already formatted by the producer ("Both under 2:00")
   *
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.HotChip.
 * Use `create(HotChipSchema)` to create a new message.
 */
export const HotChipSchema: GenMessage<HotChip> = /*@__PURE__*/
  messageDesc(file_catalog, 35);

/**
 * One half-move of the hot board's replay window.
 *
 * @generated from message chessstreamlive.catalog.v1.HotPly
 */
export type HotPly = Message<"chessstreamlive.catalog.v1.HotPly"> & {
  /**
   * SAN of the move, e.g. "Qb3". Move NUMBERING is NOT carried:
   *
   * @generated from field: string san = 1;
   */
  san: string;

  /**
   * clients derive "7. Qb3" from this ply's index + window_base_ply.
   * A preformatted label would be a second, drift-prone source of truth.
   *
   * eval AFTER the move, centipawns white-positive; absent when the
   *
   * @generated from field: optional sint32 cp = 2;
   */
  cp?: number | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.HotPly.
 * Use `create(HotPlySchema)` to create a new message.
 */
export const HotPlySchema: GenMessage<HotPly> = /*@__PURE__*/
  messageDesc(file_catalog, 36);

/**
 * A live board ranked into the "Heating Up" hero (#1279). Composed by the heat
 * module in relay-ingest and pushed WHOLE (overlay_push.v1 HotBoardsPush) to the
 * content-service, which serves the snapshot verbatim on BroadcastList.hot_boards.
 *
 * Every field is RENDERABLE or NAVIGABLE — nothing here is provenance or a
 * debugging aid: the board is drawn from fen + the window, tapped through via
 * round_id/board_id, and captioned from headline/prose/chips. Consumers take
 * the strings verbatim; they are producer-composed prose, not templates to
 * re-derive.
 *
 * @generated from message chessstreamlive.catalog.v1.HotBoardEntry
 */
export type HotBoardEntry = Message<"chessstreamlive.catalog.v1.HotBoardEntry"> & {
  /**
   * Subscribe(round_id) target (matches BroadcastEntry.round_id)
   *
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * Lichess broadcast tournament id (matches BroadcastEntry.tour_id)
   *
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * POSITIONAL board index within the round (broadcast_live.v1 board_id)
   *
   * @generated from field: uint32 board_id = 3;
   */
  boardId: number;

  /**
   * "Candidates 2026" — the event, not the round
   *
   * @generated from field: string event_name = 4;
   */
  eventName: string;

  /**
   * "Round 11" (matches BroadcastEntry.round_name)
   *
   * @generated from field: string round_name = 5;
   */
  roundName: string;

  /**
   * "ed:<slug>" → BroadcastList.editions[edition_id]; absent while unarchived
   *
   * @generated from field: optional string edition_id = 6;
   */
  editionId?: string | undefined;

  /**
   * display name, producer-formatted
   *
   * @generated from field: string white_name = 7;
   */
  whiteName: string;

  /**
   * display name, producer-formatted
   *
   * @generated from field: string black_name = 8;
   */
  blackName: string;

  /**
   * one-line hook: "Caruana clinging on with 38 seconds"
   *
   * @generated from field: string headline = 9;
   */
  headline: string;

  /**
   * 1-3 sentence why-watch paragraph
   *
   * @generated from field: string prose = 10;
   */
  prose: string;

  /**
   * heat score, 0-100 (100 = hottest); the hero's sort key
   *
   * @generated from field: uint32 tension = 11;
   */
  tension: number;

  /**
   * event tier "T1".."T4" (matches BroadcastEntry.tier); empty if unknown
   *
   * @generated from field: string tier = 12;
   */
  tier: string;

  /**
   * CURRENT position — what the board renders at rest
   *
   * @generated from field: string fen = 13;
   */
  fen: string;

  /**
   * position BEFORE window[0]; the replay's starting frame
   *
   * @generated from field: string window_start_fen = 14;
   */
  windowStartFen: string;

  /**
   * ply index (half-moves from the game start) of window[0], 0-based:
   *
   * @generated from field: uint32 window_base_ply = 15;
   */
  windowBasePly: number;

  /**
   * window[i] is game ply (window_base_ply + i). Clients derive the
   * move label as ((window_base_ply + i) / 2 + 1) with the side to move.
   * The replayable tail — the last plies leading to `fen`, oldest first.
   * CAPPED AT 16 plies by the producer: the hero shows a scrubbable recent
   * window, not the game, and the cap bounds a whole-snapshot push carrying
   * top-K boards. Consumers MUST tolerate fewer (a game shorter than the
   * window) and MUST NOT assume exactly 16.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.HotPly window = 16;
   */
  window: HotPly[];

  /**
   * eval at `fen`, centipawns white-positive; absent when unavailable
   *
   * @generated from field: optional sint32 eval_cp = 17;
   */
  evalCp?: number | undefined;

  /**
   * (mate scores are not encoded — the chips carry that story).
   * Equals the last window ply's `cp` when both are present; it is
   * carried separately because `window` may be empty or truncated.
   *
   * reason chips, producer-ordered (most salient first)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.HotChip chips = 18;
   */
  chips: HotChip[];

  /**
   * epoch ms UTC the snapshot was composed; drives the "as of" staleness
   *
   * @generated from field: int64 computed_at_ms = 19;
   */
  computedAtMs: bigint;
};

/**
 * Describes the message chessstreamlive.catalog.v1.HotBoardEntry.
 * Use `create(HotBoardEntrySchema)` to create a new message.
 */
export const HotBoardEntrySchema: GenMessage<HotBoardEntry> = /*@__PURE__*/
  messageDesc(file_catalog, 37);

/**
 * @generated from message chessstreamlive.catalog.v1.GetPlayerRequest
 */
export type GetPlayerRequest = Message<"chessstreamlive.catalog.v1.GetPlayerRequest"> & {
  /**
   * player id "fide:<id>" | "p:<name-hash>"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetPlayerRequest.
 * Use `create(GetPlayerRequestSchema)` to create a new message.
 */
export const GetPlayerRequestSchema: GenMessage<GetPlayerRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 38);

/**
 * @generated from message chessstreamlive.catalog.v1.Player
 */
export type Player = Message<"chessstreamlive.catalog.v1.Player"> & {
  /**
   * the player's own identity (live rating via GetLiveStates, not here)
   *
   * @generated from field: chessstreamlive.catalog.v1.PlayerRef ref = 1;
   */
  ref?: PlayerRef | undefined;

  /**
   * highest classical rating reached; absent if unknown
   *
   * @generated from field: optional int32 peak_elo = 2;
   */
  peakElo?: number | undefined;

  /**
   * federation/country; absent if unknown
   *
   * @generated from field: optional string country = 3;
   */
  country?: string | undefined;

  /**
   * year of birth; absent if unknown
   *
   * @generated from field: optional int32 birth_year = 4;
   */
  birthYear?: number | undefined;

  /**
   * aggregate record (precomputed at build time)
   *
   * @generated from field: chessstreamlive.catalog.v1.CareerStats career = 5;
   */
  career?: CareerStats | undefined;

  /**
   * signature games (bounded, ≤ ~10)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.GameTrack top_games = 6;
   */
  topGames: GameTrack[];

  /**
   * Recently-played editions — a bounded TEASER, not the player's event history:
   * the aggregate build keeps the 10 most recent (`pipeline/aggregate.rs:26`,
   * `RECENT_EVENTS`) and the R2 profile bundle 8 (`publish_player_profiles.rs:85`,
   * `MAX_RECENT_EVENTS`), with the remainder dropped SILENTLY. For the complete,
   * paginated list call `ListPlayerEvents`.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.EditionRef recent_events = 7;
   */
  recentEvents: EditionRef[];

  /**
   * a featured rivalry, if any
   *
   * @generated from field: optional chessstreamlive.catalog.v1.HeadToHeadRef notable_rivalry = 8;
   */
  notableRivalry?: HeadToHeadRef | undefined;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 9;
   */
  meta?: ResponseMeta | undefined;

  /**
   * opponents referenced by top_games
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 10;
   */
  players: { [key: string]: PlayerRef };

  /**
   * editions referenced by top_games (span many)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 11;
   */
  editions: { [key: string]: EditionRef };

  /**
   * mirror-of: proto/catalog.proto PlayerRef.profile_r2_url; stamped by E4o
   *
   * @generated from field: string profile_r2_url = 12;
   */
  profileR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Player.
 * Use `create(PlayerSchema)` to create a new message.
 */
export const PlayerSchema: GenMessage<Player> = /*@__PURE__*/
  messageDesc(file_catalog, 39);

/**
 * The player's COMPLETE event history, paginated — everything
 * `Player.recent_events` (bounded at 10/8) cannot carry. Cards are the same
 * `EditionRef` shape, so a caller renders one list from both sources.
 *
 * @generated from message chessstreamlive.catalog.v1.ListPlayerEventsRequest
 */
export type ListPlayerEventsRequest = Message<"chessstreamlive.catalog.v1.ListPlayerEventsRequest"> & {
  /**
   * player id "fide:<id>" | "p:<name-hash>", as GetPlayerRequest.id
   *
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * requested events per page; 0 = server default
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * opaque cursor; empty = first page
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.ListPlayerEventsRequest.
 * Use `create(ListPlayerEventsRequestSchema)` to create a new message.
 */
export const ListPlayerEventsRequestSchema: GenMessage<ListPlayerEventsRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 40);

/**
 * @generated from message chessstreamlive.catalog.v1.ListPlayerEventsResponse
 */
export type ListPlayerEventsResponse = Message<"chessstreamlive.catalog.v1.ListPlayerEventsResponse"> & {
  /**
   * ONE PAGE of the player's editions, most recent first
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.EditionRef events = 1;
   */
  events: EditionRef[];

  /**
   * cursor for the next page; empty = last
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * version + staleness (carried on every top-level response, ~:127)
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.ListPlayerEventsResponse.
 * Use `create(ListPlayerEventsResponseSchema)` to create a new message.
 */
export const ListPlayerEventsResponseSchema: GenMessage<ListPlayerEventsResponse> = /*@__PURE__*/
  messageDesc(file_catalog, 41);

/**
 * @generated from message chessstreamlive.catalog.v1.CareerStats
 */
export type CareerStats = Message<"chessstreamlive.catalog.v1.CareerStats"> & {
  /**
   * games in the archive for this player
   *
   * @generated from field: int64 total_games = 1;
   */
  totalGames: bigint;

  /**
   * total wins
   *
   * @generated from field: int64 wins = 2;
   */
  wins: bigint;

  /**
   * total draws
   *
   * @generated from field: int64 draws = 3;
   */
  draws: bigint;

  /**
   * total losses
   *
   * @generated from field: int64 losses = 4;
   */
  losses: bigint;

  /**
   * win_pct intentionally absent: derivable as wins/total_games, and the 0/0 case
   * serializes to "NaN%". Clients compute it, guarding total_games == 0. (Same for
   * HeadToHead.total = a_wins + draws + b_wins.)
   *
   * earliest archived game (partial-precision); absent if none
   *
   * @generated from field: optional chessstreamlive.catalog.v1.PartialDate first_game = 5;
   */
  firstGame?: PartialDate | undefined;

  /**
   * latest archived game (partial-precision); absent if none
   *
   * @generated from field: optional chessstreamlive.catalog.v1.PartialDate last_game = 6;
   */
  lastGame?: PartialDate | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.CareerStats.
 * Use `create(CareerStatsSchema)` to create a new message.
 */
export const CareerStatsSchema: GenMessage<CareerStats> = /*@__PURE__*/
  messageDesc(file_catalog, 42);

/**
 * @generated from message chessstreamlive.catalog.v1.GetGameRequest
 */
export type GetGameRequest = Message<"chessstreamlive.catalog.v1.GetGameRequest"> & {
  /**
   * game id "g:<12-hex move_hash>"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetGameRequest.
 * Use `create(GetGameRequestSchema)` to create a new message.
 */
export const GetGameRequestSchema: GenMessage<GetGameRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 43);

/**
 * @generated from message chessstreamlive.catalog.v1.Game
 */
export type Game = Message<"chessstreamlive.catalog.v1.Game"> & {
  /**
   * row form: players, result, opening, date
   *
   * @generated from field: chessstreamlive.catalog.v1.GameTrack track = 1;
   */
  track?: GameTrack | undefined;

  /**
   * the single owning edition (track.edition_id resolves here)
   *
   * @generated from field: chessstreamlive.catalog.v1.EditionRef edition = 2;
   */
  edition?: EditionRef | undefined;

  /**
   * round label within the edition, e.g. "11.2"
   *
   * @generated from field: string round = 3;
   */
  round: string;

  /**
   * immutable R2 bundle: movetext + clocks (heavy → CDN)
   *
   * @generated from field: string pgn_bundle_r2_url = 4;
   */
  pgnBundleR2Url: string;

  /**
   * immutable R2 per-ply eval blob; absent until/unless analyzed
   *
   * @generated from field: optional string deep_eval_r2_url = 5;
   */
  deepEvalR2Url?: string | undefined;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 6;
   */
  meta?: ResponseMeta | undefined;

  /**
   * the two participants
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 7;
   */
  players: { [key: string]: PlayerRef };

  /**
   * x/ed/<edition>.<hash16>.pb; stamped by E4o; Game.edition is a dictionary use, so its EditionRef field 12 is always empty
   *
   * @generated from field: string edition_doc_r2_url = 8;
   */
  editionDocR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Game.
 * Use `create(GameSchema)` to create a new message.
 */
export const GameSchema: GenMessage<Game> = /*@__PURE__*/
  messageDesc(file_catalog, 44);

/**
 * @generated from message chessstreamlive.catalog.v1.GetHeadToHeadRequest
 */
export type GetHeadToHeadRequest = Message<"chessstreamlive.catalog.v1.GetHeadToHeadRequest"> & {
  /**
   * first player public id
   *
   * @generated from field: string player_a = 1;
   */
  playerA: string;

  /**
   * second player public id (order-independent; server canonicalizes)
   *
   * @generated from field: string player_b = 2;
   */
  playerB: string;

  /**
   * cap on recent meetings returned; 0 = server default
   *
   * @generated from field: int32 max_games = 3;
   */
  maxGames: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetHeadToHeadRequest.
 * Use `create(GetHeadToHeadRequestSchema)` to create a new message.
 */
export const GetHeadToHeadRequestSchema: GenMessage<GetHeadToHeadRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 45);

/**
 * Compact reference to a head-to-head pairing (e.g. Player.notable_rivalry).
 *
 * @generated from message chessstreamlive.catalog.v1.HeadToHeadRef
 */
export type HeadToHeadRef = Message<"chessstreamlive.catalog.v1.HeadToHeadRef"> & {
  /**
   * h2h id "h2h:<a>:<b>" (canonical order)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * player A id (resolve via the enclosing response's players map)
   *
   * @generated from field: string a_id = 2;
   */
  aId: string;

  /**
   * player B id
   *
   * @generated from field: string b_id = 3;
   */
  bId: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.HeadToHeadRef.
 * Use `create(HeadToHeadRefSchema)` to create a new message.
 */
export const HeadToHeadRefSchema: GenMessage<HeadToHeadRef> = /*@__PURE__*/
  messageDesc(file_catalog, 46);

/**
 * @generated from message chessstreamlive.catalog.v1.HeadToHead
 */
export type HeadToHead = Message<"chessstreamlive.catalog.v1.HeadToHead"> & {
  /**
   * player A id → players[a_id]
   *
   * @generated from field: string a_id = 1;
   */
  aId: string;

  /**
   * player B id → players[b_id]
   *
   * @generated from field: string b_id = 2;
   */
  bId: string;

  /**
   * total decisive+drawn meetings
   *
   * @generated from field: int32 total = 3;
   */
  total: number;

  /**
   * games A won
   *
   * @generated from field: int32 a_wins = 4;
   */
  aWins: number;

  /**
   * games drawn
   *
   * @generated from field: int32 draws = 5;
   */
  draws: number;

  /**
   * games B won
   *
   * @generated from field: int32 b_wins = 6;
   */
  bWins: number;

  /**
   * most-recent meetings (bounded by request max_games)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.GameTrack recent = 7;
   */
  recent: GameTrack[];

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 8;
   */
  meta?: ResponseMeta | undefined;

  /**
   * A, B, and any others appearing in `recent`
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 9;
   */
  players: { [key: string]: PlayerRef };

  /**
   * editions of the recent meetings (span many)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 10;
   */
  editions: { [key: string]: EditionRef };
};

/**
 * Describes the message chessstreamlive.catalog.v1.HeadToHead.
 * Use `create(HeadToHeadSchema)` to create a new message.
 */
export const HeadToHeadSchema: GenMessage<HeadToHead> = /*@__PURE__*/
  messageDesc(file_catalog, 47);

/**
 * @generated from message chessstreamlive.catalog.v1.GetReviewRequest
 */
export type GetReviewRequest = Message<"chessstreamlive.catalog.v1.GetReviewRequest"> & {
  /**
   * game id "g:<…>"
   *
   * @generated from field: string game_id = 1;
   */
  gameId: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetReviewRequest.
 * Use `create(GetReviewRequestSchema)` to create a new message.
 */
export const GetReviewRequestSchema: GenMessage<GetReviewRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 48);

/**
 * @generated from message chessstreamlive.catalog.v1.Review
 */
export type Review = Message<"chessstreamlive.catalog.v1.Review"> & {
  /**
   * game this review belongs to
   *
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * bundle version: v1 (fast) → v2/v3 (enrichments); monotonic
   *
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * immutable R2 review bundle URL; absent until the first version exists
   *
   * @generated from field: optional string bundle_r2_url = 3;
   */
  bundleR2Url?: string | undefined;

  /**
   * short summary for cards without fetching the bundle; absent if none
   *
   * @generated from field: optional string inline_summary = 4;
   */
  inlineSummary?: string | undefined;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 5;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Review.
 * Use `create(ReviewSchema)` to create a new message.
 */
export const ReviewSchema: GenMessage<Review> = /*@__PURE__*/
  messageDesc(file_catalog, 49);

/**
 * @generated from message chessstreamlive.catalog.v1.GetRatingListRequest
 */
export type GetRatingListRequest = Message<"chessstreamlive.catalog.v1.GetRatingListRequest"> & {
  /**
   * rating list: "standard" | "rapid" | "blitz"
   *
   * @generated from field: string list = 1;
   */
  list: string;

  /**
   * number of top entries to return; 0 = server default
   *
   * @generated from field: int32 top_n = 2;
   */
  topN: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetRatingListRequest.
 * Use `create(GetRatingListRequestSchema)` to create a new message.
 */
export const GetRatingListRequestSchema: GenMessage<GetRatingListRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 50);

/**
 * @generated from message chessstreamlive.catalog.v1.RatingList
 */
export type RatingList = Message<"chessstreamlive.catalog.v1.RatingList"> & {
  /**
   * echoes the requested list
   *
   * @generated from field: string list = 1;
   */
  list: string;

  /**
   * ranked entries, best first
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.RatingEntry entries = 2;
   */
  entries: RatingEntry[];

  /**
   * version + staleness (short-TTL: this response IS live data)
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.RatingList.
 * Use `create(RatingListSchema)` to create a new message.
 */
export const RatingListSchema: GenMessage<RatingList> = /*@__PURE__*/
  messageDesc(file_catalog, 51);

/**
 * @generated from message chessstreamlive.catalog.v1.RatingEntry
 */
export type RatingEntry = Message<"chessstreamlive.catalog.v1.RatingEntry"> & {
  /**
   * 1-based position on the live list
   *
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * inline identity (distinct per entry — dictionary gives no dedup benefit here)
   *
   * @generated from field: chessstreamlive.catalog.v1.PlayerRef player = 2;
   */
  player?: PlayerRef | undefined;

  /**
   * the live rating + delta (carried inline because this response IS the live data)
   *
   * @generated from field: chessstreamlive.catalog.v1.LiveRating rating = 3;
   */
  rating?: LiveRating | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.RatingEntry.
 * Use `create(RatingEntrySchema)` to create a new message.
 */
export const RatingEntrySchema: GenMessage<RatingEntry> = /*@__PURE__*/
  messageDesc(file_catalog, 52);

/**
 * @generated from message chessstreamlive.catalog.v1.GetLiveStatesRequest
 */
export type GetLiveStatesRequest = Message<"chessstreamlive.catalog.v1.GetLiveStatesRequest"> & {
  /**
   * players to hydrate live ratings for (viewport-bounded, ≤ ~50)
   *
   * @generated from field: repeated string player_ids = 1;
   */
  playerIds: string[];

  /**
   * games to hydrate review statuses for (viewport-bounded, ≤ ~50)
   *
   * @generated from field: repeated string game_ids = 2;
   */
  gameIds: string[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetLiveStatesRequest.
 * Use `create(GetLiveStatesRequestSchema)` to create a new message.
 */
export const GetLiveStatesRequestSchema: GenMessage<GetLiveStatesRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 53);

/**
 * @generated from message chessstreamlive.catalog.v1.LiveStates
 */
export type LiveStates = Message<"chessstreamlive.catalog.v1.LiveStates"> & {
  /**
   * live rating keyed by player id (only ids that have one)
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.LiveRating> ratings = 1;
   */
  ratings: { [key: string]: LiveRating };

  /**
   * review readiness keyed by game id
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.ReviewStatus> review_statuses = 2;
   */
  reviewStatuses: { [key: string]: ReviewStatus };

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.LiveStates.
 * Use `create(LiveStatesSchema)` to create a new message.
 */
export const LiveStatesSchema: GenMessage<LiveStates> = /*@__PURE__*/
  messageDesc(file_catalog, 54);

/**
 * @generated from message chessstreamlive.catalog.v1.GetPuzzleSetRequest
 */
export type GetPuzzleSetRequest = Message<"chessstreamlive.catalog.v1.GetPuzzleSetRequest"> & {
  /**
   * filter by theme tag, e.g. "fork"; absent = any
   *
   * @generated from field: optional string theme = 1;
   */
  theme?: string | undefined;

  /**
   * inclusive lower puzzle-rating bound; absent = no floor
   *
   * @generated from field: optional int32 rating_min = 2;
   */
  ratingMin?: number | undefined;

  /**
   * inclusive upper puzzle-rating bound; absent = no ceiling
   *
   * @generated from field: optional int32 rating_max = 3;
   */
  ratingMax?: number | undefined;

  /**
   * "from this event" minted puzzles; absent = whole corpus
   *
   * @generated from field: optional string edition_id = 4;
   */
  editionId?: string | undefined;

  /**
   * requested puzzles per page; 0 = server default.
   *
   * @generated from field: int32 count = 5;
   */
  count: number;

  /**
   * AIP-158 would name this page_size; the rename is
   * binary-wire-safe (same tag) but changes json_name and
   * generated-source names, so the breaking gate blocks it —
   * rename only at a coordinated proto+client regen.
   *
   * opaque cursor; empty = first page
   *
   * @generated from field: string page_token = 6;
   */
  pageToken: string;

  /**
   * filter to a single Lichess opening tag, e.g. "Russian_Game_Stafford_Gambit"; empty = no filter
   *
   * @generated from field: string opening_tag = 7;
   */
  openingTag: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetPuzzleSetRequest.
 * Use `create(GetPuzzleSetRequestSchema)` to create a new message.
 */
export const GetPuzzleSetRequestSchema: GenMessage<GetPuzzleSetRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 55);

/**
 * @generated from message chessstreamlive.catalog.v1.PuzzleSet
 */
export type PuzzleSet = Message<"chessstreamlive.catalog.v1.PuzzleSet"> & {
  /**
   * puzzle metadata page (no solutions — see PuzzleCard)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.PuzzleCard puzzles = 1;
   */
  puzzles: PuzzleCard[];

  /**
   * offline packs on R2 covering this query
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.PackRef packs = 2;
   */
  packs: PackRef[];

  /**
   * cursor for the next page; empty = last
   *
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 4;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PuzzleSet.
 * Use `create(PuzzleSetSchema)` to create a new message.
 */
export const PuzzleSetSchema: GenMessage<PuzzleSet> = /*@__PURE__*/
  messageDesc(file_catalog, 56);

/**
 * Anonymous puzzle metadata — NO solution here. Solutions ship in the offline
 * pack (PackRef.pack_r2_url) and via the server-validated chess.puzzle.v1
 * SolvePuzzle flow. For the CC0 corpus omitting them is hygiene, not protection
 * (those answers are a public Lichess download); real anti-cheat is server-side
 * validation. (The shared daily ladder is a separate, intentional surface — see
 * common.v1.Puzzle / GetDailyLadder — and ships solutions for client-side solving.)
 *
 * @generated from message chessstreamlive.catalog.v1.PuzzleCard
 */
export type PuzzleCard = Message<"chessstreamlive.catalog.v1.PuzzleCard"> & {
  /**
   * puzzle public id "pz:<content-hash>" (§4.3)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * starting position (FEN) the user is presented
   *
   * @generated from field: string fen = 2;
   */
  fen: string;

  /**
   * theme tags, e.g. ["fork","endgame"]
   *
   * @generated from field: repeated string themes = 4;
   */
  themes: string[];

  /**
   * puzzle difficulty rating (Lichess/Glicko-style)
   *
   * @generated from field: int32 rating = 5;
   */
  rating: number;

  /**
   * game this puzzle was minted from "g:<…>"; absent for imported puzzles
   *
   * @generated from field: optional string source_game_id = 6;
   */
  sourceGameId?: string | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PuzzleCard.
 * Use `create(PuzzleCardSchema)` to create a new message.
 */
export const PuzzleCardSchema: GenMessage<PuzzleCard> = /*@__PURE__*/
  messageDesc(file_catalog, 57);

/**
 * @generated from message chessstreamlive.catalog.v1.PackRef
 */
export type PackRef = Message<"chessstreamlive.catalog.v1.PackRef"> & {
  /**
   * theme this pack covers
   *
   * @generated from field: string theme = 1;
   */
  theme: string;

  /**
   * difficulty band index (e.g. 0 = 800-1000, …) — partition key
   *
   * @generated from field: int32 rating_band = 2;
   */
  ratingBand: number;

  /**
   * immutable, content-addressed R2 pack (carries FENs + SOLUTIONS for offline solve)
   *
   * @generated from field: string pack_r2_url = 3;
   */
  packR2Url: string;

  /**
   * number of puzzles in the pack
   *
   * @generated from field: int32 count = 4;
   */
  count: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PackRef.
 * Use `create(PackRefSchema)` to create a new message.
 */
export const PackRefSchema: GenMessage<PackRef> = /*@__PURE__*/
  messageDesc(file_catalog, 58);

/**
 * @generated from message chessstreamlive.catalog.v1.GetDailyLadderRequest
 */
export type GetDailyLadderRequest = Message<"chessstreamlive.catalog.v1.GetDailyLadderRequest"> & {
  /**
   * "YYYY-MM-DD" (UTC). Clients ALWAYS compute and send the explicit date; the server does NOT
   * resolve an empty date — an empty value returns NOT_FOUND. This keeps every request a
   * deterministic by-date lookup, so any response is safely edge-cacheable.
   *
   * @generated from field: string date = 1;
   */
  date: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetDailyLadderRequest.
 * Use `create(GetDailyLadderRequestSchema)` to create a new message.
 */
export const GetDailyLadderRequestSchema: GenMessage<GetDailyLadderRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 59);

/**
 * One day's shared puzzle ladder, ordered easy→hard. Immutable once published.
 *
 * @generated from message chessstreamlive.catalog.v1.DailyLadder
 */
export type DailyLadder = Message<"chessstreamlive.catalog.v1.DailyLadder"> & {
  /**
   * "YYYY-MM-DD" (UTC)
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * ascending difficulty (order = rung)
   *
   * @generated from field: repeated chessstreamlive.common.v1.Puzzle puzzles = 2;
   */
  puzzles: Puzzle[];

  /**
   * content version + staleness (catalog invariant)
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.DailyLadder.
 * Use `create(DailyLadderSchema)` to create a new message.
 */
export const DailyLadderSchema: GenMessage<DailyLadder> = /*@__PURE__*/
  messageDesc(file_catalog, 60);

/**
 * @generated from message chessstreamlive.catalog.v1.SearchRequest
 */
export type SearchRequest = Message<"chessstreamlive.catalog.v1.SearchRequest"> & {
  /**
   * raw query; server normalizes (lower/trim/collapse) for cache-key hygiene
   *
   * @generated from field: string q = 1;
   */
  q: string;

  /**
   * restrict to these entity types; empty = all
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.EntityType types = 2;
   */
  types: EntityType[];

  /**
   * requested results per page; 0 = server default
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * opaque cursor; empty = first page
   *
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * ── Server-first facets (#1369; expansion model §3.4) ────────────────────
   * All four values come from the SERVER'S PUBLISHED VOCABULARY: they are derived
   * build-side onto every indexed entity, never client-invented tags, and never
   * free text matched by substring. Shared-vocabulary dimensions, so they fold
   * into the edge-cache key without fragmenting it per user.
   *
   * Semantics, identical on every axis and on both engines (server + on-device):
   *   * empty      = no filter on that axis;
   *   * a known value = keep only entities carrying it (entities that carry
   *     NOTHING on that axis are excluded — they are not "any");
   *   * an UNKNOWN or unmatchable value FAILS CLOSED to an empty result set —
   *     never a wildcard widen, never an error channel that reflects the input.
   *     Deliberate: a *selected* filter that silently widens is worse than an
   *     honest empty state.
   *
   * Canonical section vocabulary (lowercase): "open" | "women" | "junior" |
   * "senior". Anything else is unknown ⇒ empty results.
   *
   * @generated from field: string section = 5;
   */
  section: string;

  /**
   * 3-letter uppercase FIDE/IOC federation code, e.g. "NOR". The server
   * uppercases what it receives; a value nothing carries yields empty results.
   *
   * @generated from field: string federation = 6;
   */
  federation: string;

  /**
   * Event tier, same axis and same three-clause semantics as above. Canonical
   * vocabulary (UPPERCASE): "T1" | "T2" | "T3" | "T4" — the same spelling
   * `EditionRef.tier` / `Series.tier` / `BroadcastEntry.tier` already carry. The
   * server uppercases what it receives; anything outside the vocabulary is
   * unknown ⇒ empty results.
   *
   * `string`, not an enum, matching the `section` precedent: an enum would make
   * the closed vocabulary self-documenting on the wire, but it would split the
   * normalize/fail-closed code path that `src/search/facets.rs` deliberately
   * unifies — one module where a facet's stored spelling and its accepted query
   * spelling are defined together. Two normalization shapes (parse-enum for one
   * axis, string-normalize for the others) is exactly the divergence that
   * module exists to prevent.
   *
   * @generated from field: string tier = 7;
   */
  tier: string;

  /**
   * Calendar year, same axis and same three-clause semantics as above. 0 = no
   * filter on this axis (the empty value for an int facet, exactly as `""` is
   * for the string ones); any non-zero year nothing carries yields empty
   * results, never a wildcard widen.
   *
   * The axis is uniform because every searchable entity now CAN carry a year —
   * what an entity matches on differs by type, and both rules are equality on
   * the entity's own published facts, never a range the caller supplies:
   *   * an EDITION matches by EQUALITY on its own year (`Edition.year` /
   *     `EditionRef.year`);
   *   * a SERIES matches by SPAN CONTAINMENT, `first_year <= year <= last_year`
   *     (`Series.first_year`/`last_year`, derived build-side as min/max over the
   *     series' editions with a KNOWN year).
   * An entity carrying nothing on the axis is EXCLUDED, not treated as "any" —
   * an edition whose year is unknown, and a series whose editions ALL lack a
   * year (so it has no span at all), drop out of a year-filtered query. This is
   * what #1802 reserved the number for: the answer is "derive a series year
   * range", so a `year` filter no longer empties the series half of the
   * Tournaments chip.
   *
   * `int32`, not a string: unlike the vocabulary axes there is nothing to
   * normalize — a year is already its own canonical spelling — so `facets.rs`
   * gains a range check, not a second normalization shape.
   *
   * @generated from field: int32 year = 9;
   */
  year: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 61);

/**
 * @generated from message chessstreamlive.catalog.v1.SearchResponse
 */
export type SearchResponse = Message<"chessstreamlive.catalog.v1.SearchResponse"> & {
  /**
   * ranked results as the same polymorphic cards as feeds
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.PlayableItem results = 1;
   */
  results: PlayableItem[];

  /**
   * cursor for the next page; empty = last
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * version + staleness
   *
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 3;
   */
  meta?: ResponseMeta | undefined;

  /**
   * dictionary for any GameTrack refs in results
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.PlayerRef> players = 4;
   */
  players: { [key: string]: PlayerRef };

  /**
   * dictionary for any GameTrack edition refs in results
   *
   * @generated from field: map<string, chessstreamlive.catalog.v1.EditionRef> editions = 5;
   */
  editions: { [key: string]: EditionRef };

  /**
   * set iff the query was FEN-shaped. Writer: search indexer; reader: app
   *
   * @generated from field: chessstreamlive.catalog.v1.PositionLookup position = 6;
   */
  position?: PositionLookup | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_catalog, 62);

/**
 * A single round within a tournament. Writer: relay-control / publishers;
 * reader: content-service / app.
 *
 * @generated from message chessstreamlive.catalog.v1.Round
 */
export type Round = Message<"chessstreamlive.catalog.v1.Round"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * @generated from field: uint32 number = 2;
   */
  number: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * absent for startsAfterPrevious/unknown (mirrors BroadcastEntry)
   *
   * @generated from field: optional int64 starts_at_ms = 4;
   */
  startsAtMs?: bigint | undefined;

  /**
   * State AS OF THE PRODUCING WRITE. Deliberate, bounded tension with the
   * bucket-membership rule (#278 D1, BroadcastList): the tournament-detail
   * view is not bucketed, so rounds carry a state here — but while an event
   * is live the VOLATILE plane is authoritative (GetTournament's merge
   * overrides this from live pushes); in an archived doc it is history
   * (FINISHED). Producers never populate this to contradict the calendar.
   *
   * @generated from field: chessstreamlive.catalog.v1.BroadcastLiveState state = 5;
   */
  state: BroadcastLiveState;

  /**
   * absent if unknown (mirrors BroadcastEntry)
   *
   * @generated from field: optional int32 board_count = 6;
   */
  boardCount?: number | undefined;

  /**
   * this round's games — frozen at publish; empty while live
   *
   * @generated from field: repeated string game_ids = 7;
   */
  gameIds: string[];

  /**
   * Crosstable cumulative through this round — the "time-travel" state: scores
   * added up from round 1 to here. Absent = not computable for this round
   * (e.g. archive games with unknown round numbers), which readers must
   * distinguish from an empty table — hence the message wrapper, mirroring
   * Tournament.standings.
   *
   * @generated from field: optional chessstreamlive.catalog.v1.TournamentStandings standings = 8;
   */
  standings?: TournamentStandings | undefined;

  /**
   * When this round's durable data was last populated by the backfill pipeline
   * (issue #697), in epoch-ms. 0/absent = unknown/legacy (never populated by the
   * pipeline, e.g. archive-seeded or volatile-only rounds). Per-round provenance
   * grain so serving can answer "how fresh is this round's data?" independently of
   * the namespace-level manifest provenance.
   *
   * @generated from field: optional int64 populated_at_ms = 9;
   */
  populatedAtMs?: bigint | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Round.
 * Use `create(RoundSchema)` to create a new message.
 */
export const RoundSchema: GenMessage<Round> = /*@__PURE__*/
  messageDesc(file_catalog, 63);

/**
 * Cross-table for a tournament. Writer: relay-control / publishers;
 * reader: content-service / app.
 *
 * @generated from message chessstreamlive.catalog.v1.TournamentStandings
 */
export type TournamentStandings = Message<"chessstreamlive.catalog.v1.TournamentStandings"> & {
  /**
   * the INDIVIDUAL plane; a team event publishes this too (per board)
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.Standing rows = 1;
   */
  rows: Standing[];

  /**
   * The TEAM plane, present iff the edition's rules describe a team fixture.
   * Empty on an individual event, and empty — never a zero-filled table — when a
   * team event's feed carried no usable team tags. Both planes come from ONE
   * engine run over one game set, so they can never disagree about a result.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.TeamStanding team_rows = 2;
   */
  teamRows: TeamStanding[];

  /**
   * The SERVED POSTURE of this table, in the producer's own words (#730/#712).
   * OUR table is computed from the broadcast (or copied from an operator-curated
   * final table); it is never the arbiter's, so every non-empty table carries a
   * label saying so. The wording has exactly ONE owner — the Rust constants
   * `content_service::pipeline::standings::{COMPUTED,CURATED}_STANDINGS_NOTE` —
   * and clients RENDER it verbatim: no client derives, translates or infers a
   * label from `result_source`, emptiness or any other field.
   *
   * PRODUCER invariant (this version onwards): a table we mint is labelled iff
   * it has rows — set on every non-empty table, empty on an empty document.
   * READER rule: EMPTY = posture UNKNOWN, i.e. UNLABELLED — never "there is no
   * table". Two producers legitimately serve rows with an empty note: a
   * document published BEFORE this field existed (every already-published doc,
   * until it is republished) and the volatile live plane (relay-control, which
   * does not stamp the posture yet). A client that sees rows with an empty note
   * renders the rows with NO label and NO link, and never substitutes a
   * wording, a heading or a URL of its own.
   *
   * @generated from field: string provenance_note = 3;
   */
  provenanceNote: string;

  /**
   * The tournament's OWN official standings page, when the feed published one:
   * Lichess `TournamentInfo.standings` (`broadcast_live.proto` TournamentInfo.standings = 8)
   * carried through the drain bundle's `edition.json`. NEVER a hard-coded
   * organiser or chess-results address, and never arbiter DATA — we link, we do
   * not ingest (chess-results ToS §3; the scraped tables are a calibration
   * oracle only). EMPTY = the feed published no such page; a client renders the
   * note alone and MUST NOT substitute a guess.
   *
   * @generated from field: string official_standings_url = 4;
   */
  officialStandingsUrl: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.TournamentStandings.
 * Use `create(TournamentStandingsSchema)` to create a new message.
 */
export const TournamentStandingsSchema: GenMessage<TournamentStandings> = /*@__PURE__*/
  messageDesc(file_catalog, 64);

/**
 * The full tournament document, keyed by edition_id. Writer: relay-control /
 * publishers (tournament_doc table); reader: content-service / app.
 * IMMUTABLE AT REST: version metadata about the served view lives on
 * GetTournamentResponse (the RPC envelope), never inside this entity — the
 * stored blob stays a byte-for-byte passthrough candidate (invariant 2, ~:17).
 *
 * @generated from message chessstreamlive.catalog.v1.Tournament
 */
export type Tournament = Message<"chessstreamlive.catalog.v1.Tournament"> & {
  /**
   * @generated from field: string edition_id = 1;
   */
  editionId: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string tier = 4;
   */
  tier: string;

  /**
   * @generated from field: string image_r2_url = 5;
   */
  imageR2Url: string;

  /**
   * @generated from field: string series_id = 6;
   */
  seriesId: string;

  /**
   * @generated from field: repeated chessstreamlive.catalog.v1.Round rounds = 7;
   */
  rounds: Round[];

  /**
   * @generated from field: chessstreamlive.catalog.v1.TournamentStandings standings = 8;
   */
  standings?: TournamentStandings | undefined;

  /**
   * Populated only for decided/finished events; entries are rank <= 3 in rank order;
   * shared places may repeat a rank; at most 5 entries. display_name denormalized so card
   * surfaces need no player-map join.
   *
   * @generated from field: repeated chessstreamlive.catalog.v1.PodiumEntry podium = 11;
   */
  podium: PodiumEntry[];

  /**
   * How `edition_id` was minted (design R5). Deterministic → hash-stable.
   *
   * @generated from field: chessstreamlive.catalog.v1.IdProvenance id_provenance = 12;
   */
  idProvenance?: IdProvenance | undefined;

  /**
   * value of Edition.bulk_pack_r2_url = 9; stamped by E5
   *
   * @generated from field: string bulk_pack_r2_url = 13;
   */
  bulkPackR2Url: string;

  /**
   * value Search stamps on EditionRef.experience_r2_url = 7; stamped by E4o
   *
   * @generated from field: string experience_r2_url = 14;
   */
  experienceR2Url: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.Tournament.
 * Use `create(TournamentSchema)` to create a new message.
 */
export const TournamentSchema: GenMessage<Tournament> = /*@__PURE__*/
  messageDesc(file_catalog, 65);

/**
 * @generated from message chessstreamlive.catalog.v1.PodiumEntry
 */
export type PodiumEntry = Message<"chessstreamlive.catalog.v1.PodiumEntry"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: int32 rank = 3;
   */
  rank: number;
};

/**
 * Describes the message chessstreamlive.catalog.v1.PodiumEntry.
 * Use `create(PodiumEntrySchema)` to create a new message.
 */
export const PodiumEntrySchema: GenMessage<PodiumEntry> = /*@__PURE__*/
  messageDesc(file_catalog, 66);

/**
 * Request for Catalog.GetTournament.
 *
 * @generated from message chessstreamlive.catalog.v1.GetTournamentRequest
 */
export type GetTournamentRequest = Message<"chessstreamlive.catalog.v1.GetTournamentRequest"> & {
  /**
   * @generated from field: string edition_id = 1;
   */
  editionId: string;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetTournamentRequest.
 * Use `create(GetTournamentRequestSchema)` to create a new message.
 */
export const GetTournamentRequestSchema: GenMessage<GetTournamentRequest> = /*@__PURE__*/
  messageDesc(file_catalog, 67);

/**
 * Response ENVELOPE for Catalog.GetTournament: the entity stays pristine (for
 * a fully-published tournament it is the stored doc byte-for-byte); all as-of
 * version metadata rides the SHARED ResponseMeta (base_version/volatile_seq —
 * see ResponseMeta), injected at the RPC shell, never into the entity.
 *
 * @generated from message chessstreamlive.catalog.v1.GetTournamentResponse
 */
export type GetTournamentResponse = Message<"chessstreamlive.catalog.v1.GetTournamentResponse"> & {
  /**
   * @generated from field: chessstreamlive.catalog.v1.Tournament tournament = 1;
   */
  tournament?: Tournament | undefined;

  /**
   * @generated from field: chessstreamlive.catalog.v1.ResponseMeta meta = 2;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message chessstreamlive.catalog.v1.GetTournamentResponse.
 * Use `create(GetTournamentResponseSchema)` to create a new message.
 */
export const GetTournamentResponseSchema: GenMessage<GetTournamentResponse> = /*@__PURE__*/
  messageDesc(file_catalog, 68);

/**
 * Marker for a live-hydrated module source (schedule window / live-now): the
 * module's content comes from the volatile plane at read time. Deliberately an
 * empty MESSAGE, not a bool — a oneof case should carry no meaningless scalar,
 * and this leaves room for window parameters (span, caps) without a new field.
 *
 * @generated from message chessstreamlive.catalog.v1.LiveWindowConfig
 */
export type LiveWindowConfig = Message<"chessstreamlive.catalog.v1.LiveWindowConfig"> & {
};

/**
 * Describes the message chessstreamlive.catalog.v1.LiveWindowConfig.
 * Use `create(LiveWindowConfigSchema)` to create a new message.
 */
export const LiveWindowConfigSchema: GenMessage<LiveWindowConfig> = /*@__PURE__*/
  messageDesc(file_catalog, 69);

/**
 * A single feed module. Writer: feed producer; reader: app.
 *
 * `type` (the flat render switch) and `source` (the data binding) are two
 * discriminators; the AUTHORITATIVE type → source mapping is:
 *   EDITORIAL_CAROUSEL                      → no source; inline_items REQUIRED
 *   COLLECTION_SHELF | CHAMPIONS_GALLERY
 *     | TRENDING_SHELF                      → collection_id REQUIRED
 *   PUZZLE_LADDER                           → ladder_date OR daily_base_ref
 *   SCHEDULE_WINDOW | LIVE_NOW              → live_window REQUIRED
 *   DAILY_TRAP                              → daily_base_ref REQUIRED
 * The publisher VALIDATES this mapping at publish time and drops violating
 * modules (with a warning); readers treat a violating module as malformed and
 * drop it rather than guessing. Illegal states are thus representable but
 * never published — accepted trade for keeping the flat render enum.
 *
 * @generated from message chessstreamlive.catalog.v1.FeedModule
 */
export type FeedModule = Message<"chessstreamlive.catalog.v1.FeedModule"> & {
  /**
   * @generated from field: string module_id = 1;
   */
  moduleId: string;

  /**
   * @generated from field: chessstreamlive.catalog.v1.FeedModuleType type = 2;
   */
  type: FeedModuleType;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string subtitle = 4;
   */
  subtitle: string;

  /**
   * @generated from oneof chessstreamlive.catalog.v1.FeedModule.source
   */
  source: {
    /**
     * @generated from field: string collection_id = 5;
     */
    value: string;
    case: "collectionId";
  } | {
    /**
     * @generated from field: chessstreamlive.catalog.v1.LiveWindowConfig live_window = 6;
     */
    value: LiveWindowConfig;
    case: "liveWindow";
  } | {
    /**
     * @generated from field: string ladder_date = 7;
     */
    value: string;
    case: "ladderDate";
  } | {
    /**
     * Reference the client resolves into the fetch URL for the current
     * R2 daily object family (e.g., `DailyTrap` or `PuzzleLadder`). "Current" is
     * the client's LOCAL calendar date, not a UTC day: the client composes the
     * final date-keyed URL from this base ref plus its user-local date (the
     * sanctioned exception to "clients never construct object keys" — #1178
     * §3.8, documented in daily_trap_x.proto's header). The format is
     * `<daily_base_ref>/x/d/<feature>/<YYYY-MM-DD>.pb`, and the serving layer
     * enforces a coarse per-key validity envelope on the gated
     * `x/d/<feature>/<date>` family.
     *
     * @generated from field: string daily_base_ref = 9;
     */
    value: string;
    case: "dailyBaseRef";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated chessstreamlive.catalog.v1.PlayableItem inline_items = 8;
   */
  inlineItems: PlayableItem[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.FeedModule.
 * Use `create(FeedModuleSchema)` to create a new message.
 */
export const FeedModuleSchema: GenMessage<FeedModule> = /*@__PURE__*/
  messageDesc(file_catalog, 70);

/**
 * FEN-shaped search result metadata. Writer: search indexer; reader: app.
 *
 * @generated from message chessstreamlive.catalog.v1.PositionLookup
 */
export type PositionLookup = Message<"chessstreamlive.catalog.v1.PositionLookup"> & {
  /**
   * @generated from field: string fen = 1;
   */
  fen: string;

  /**
   * @generated from field: string opening_name = 2;
   */
  openingName: string;

  /**
   * @generated from field: string eco = 3;
   */
  eco: string;

  /**
   * @generated from field: string opening_collection_id = 4;
   */
  openingCollectionId: string;

  /**
   * @generated from field: uint64 master_game_count = 5;
   */
  masterGameCount: bigint;

  /**
   * @generated from field: repeated chessstreamlive.catalog.v1.PlayableItem hot_games = 6;
   */
  hotGames: PlayableItem[];
};

/**
 * Describes the message chessstreamlive.catalog.v1.PositionLookup.
 * Use `create(PositionLookupSchema)` to create a new message.
 */
export const PositionLookupSchema: GenMessage<PositionLookup> = /*@__PURE__*/
  messageDesc(file_catalog, 71);

/**
 * How a collection/shelf was curated.
 *
 * @generated from enum chessstreamlive.catalog.v1.CuratorType
 */
export enum CuratorType {
  /**
   * unset/unknown — clients render as editorial
   *
   * @generated from enum value: CURATOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * hand-curated ("WCC History")
   *
   * @generated from enum value: CURATOR_TYPE_EDITORIAL = 1;
   */
  EDITORIAL = 1,

  /**
   * population-level "mix" (NOT per-user)
   *
   * @generated from enum value: CURATOR_TYPE_ALGORITHMIC = 2;
   */
  ALGORITHMIC = 2,

  /**
   * auto "essentials" set for one player
   *
   * @generated from enum value: CURATOR_TYPE_PLAYER_ESSENTIALS = 3;
   */
  PLAYER_ESSENTIALS = 3,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.CuratorType.
 */
export const CuratorTypeSchema: GenEnum<CuratorType> = /*@__PURE__*/
  enumDesc(file_catalog, 0);

/**
 * Provenance class of a game result, ordered by trust (#2095/#2087). The ordering
 * is a POLICY, not the enum numbering — `pipeline::twins::precedence` is the one
 * place it is written down; readers must not re-derive it from field numbers.
 *
 * Only ARCHIVE, BROADCAST and UNSPECIFIED are ever served. ARBITER is retained as
 * a wire-compatible arm and is UNREACHABLE: an organiser's published board sheet
 * is a calibration oracle for our own standings and result algorithms, not
 * something we republish (owner ruling 2026-09-14), so the overlay it is staged
 * into is a validation store that no publisher reads. A reader must treat ARBITER
 * as "cannot occur", not as "not seen yet", and must not build an "official
 * result" affordance on it.
 *
 * @generated from enum chessstreamlive.catalog.v1.ResultSource
 */
export enum ResultSource {
  /**
   * unattributed row, or a producer predating the collapse
   *
   * @generated from enum value: RESULT_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * RESERVED, never produced — an outside authority's board sheet is calibration input, not served data
   *
   * @generated from enum value: RESULT_SOURCE_ARBITER = 1;
   */
  ARBITER = 1,

  /**
   * a curated game archive (PGN Mentor / AJ-OTB / TWIC-lineage files)
   *
   * @generated from enum value: RESULT_SOURCE_ARCHIVE = 2;
   */
  ARCHIVE = 2,

  /**
   * a relay/Lichess broadcast PGN — the feed, which an archive file may outrank
   *
   * @generated from enum value: RESULT_SOURCE_BROADCAST = 3;
   */
  BROADCAST = 3,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.ResultSource.
 */
export const ResultSourceSchema: GenEnum<ResultSource> = /*@__PURE__*/
  enumDesc(file_catalog, 1);

/**
 * @generated from enum chessstreamlive.catalog.v1.BroadcastLiveState
 */
export enum BroadcastLiveState {
  /**
   * @generated from enum value: BROADCAST_LIVE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * not yet streaming (starts_at_ms future or unknown)
   *
   * @generated from enum value: BROADCAST_LIVE_STATE_SCHEDULED = 1;
   */
  SCHEDULED = 1,

  /**
   * a relay holds the slot and is pushing — watchable NOW
   *
   * @generated from enum value: BROADCAST_LIVE_STATE_STREAMING = 2;
   */
  STREAMING = 2,

  /**
   * round over
   *
   * @generated from enum value: BROADCAST_LIVE_STATE_FINISHED = 3;
   */
  FINISHED = 3,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.BroadcastLiveState.
 */
export const BroadcastLiveStateSchema: GenEnum<BroadcastLiveState> = /*@__PURE__*/
  enumDesc(file_catalog, 2);

/**
 * Why a chip is on a hot board — the REASON dimension of the heat score, so the
 * client can pick an icon/tint without parsing `label`. The label carries the
 * numbers ("0:38 on the clock"); the kind carries the meaning.
 *
 * @generated from enum chessstreamlive.catalog.v1.HotChipKind
 */
export enum HotChipKind {
  /**
   * legacy/unknown producer — clients render label-only, never drop the chip
   *
   * @generated from enum value: HOT_CHIP_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * time pressure (low clock, mutual scramble)
   *
   * @generated from enum value: HOT_CHIP_KIND_CLOCK = 1;
   */
  CLOCK = 1,

  /**
   * the evaluation moved sharply
   *
   * @generated from enum value: HOT_CHIP_KIND_EVAL_SWING = 2;
   */
  EVAL_SWING = 2,

  /**
   * knife-edge / decisive imbalance — where the eval SITS
   *
   * @generated from enum value: HOT_CHIP_KIND_BALANCE = 3;
   */
  BALANCE = 3,

  /**
   * the position itself (long think, sharp tactical moment)
   *
   * @generated from enum value: HOT_CHIP_KIND_MOMENT = 4;
   */
  MOMENT = 4,

  /**
   * proved short mate on the board; poster fast-track signal
   *
   * @generated from enum value: HOT_CHIP_KIND_MATE = 6;
   */
  MATE = 6,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.HotChipKind.
 */
export const HotChipKindSchema: GenEnum<HotChipKind> = /*@__PURE__*/
  enumDesc(file_catalog, 3);

/**
 * Review readiness — the volatile bit, delivered by GetLiveStates, never NOT_FOUND.
 *
 * @generated from enum chessstreamlive.catalog.v1.ReviewStatus
 */
export enum ReviewStatus {
  /**
   * unset/unknown
   *
   * @generated from enum value: REVIEW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * game just finished; review being generated (≤5-min window) — client shows "Computing review…"
   *
   * @generated from enum value: REVIEW_STATUS_COMPUTING = 1;
   */
  COMPUTING = 1,

  /**
   * bundle published and fetchable
   *
   * @generated from enum value: REVIEW_STATUS_READY = 2;
   */
  READY = 2,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.ReviewStatus.
 */
export const ReviewStatusSchema: GenEnum<ReviewStatus> = /*@__PURE__*/
  enumDesc(file_catalog, 4);

/**
 * @generated from enum chessstreamlive.catalog.v1.EntityType
 */
export enum EntityType {
  /**
   * unset
   *
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * players
   *
   * @generated from enum value: ENTITY_TYPE_PLAYER = 1;
   */
  PLAYER = 1,

  /**
   * event editions
   *
   * @generated from enum value: ENTITY_TYPE_EDITION = 2;
   */
  EDITION = 2,

  /**
   * event series
   *
   * @generated from enum value: ENTITY_TYPE_SERIES = 3;
   */
  SERIES = 3,

  /**
   * games
   *
   * @generated from enum value: ENTITY_TYPE_GAME = 4;
   */
  GAME = 4,

  /**
   * collections/playlists
   *
   * @generated from enum value: ENTITY_TYPE_COLLECTION = 5;
   */
  COLLECTION = 5,

  /**
   * openings (#1152 — the daily opening-trap search surface)
   *
   * @generated from enum value: ENTITY_TYPE_OPENING = 6;
   */
  OPENING = 6,

  /**
   * Opening traps. Contract-only until an indexer writes trap rows; completes the
   * on-device 't' etype's wire mapping — see
   * docs/search/search-entity-expansion-model-2026-08.md §3.1.
   *
   * LEADING block, not a trailing comment: protoc attaches only the SAME-LINE
   * portion of a trailing comment to the generated symbol, so the multi-line
   * version of this landed in Swift truncated mid-sentence on an unclosed paren,
   * losing the doc pointer entirely.
   *
   * @generated from enum value: ENTITY_TYPE_TRAP = 7;
   */
  TRAP = 7,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_catalog, 5);

/**
 * Type discriminator for feed modules. Writer: feed producer; reader: app.
 *
 * @generated from enum chessstreamlive.catalog.v1.FeedModuleType
 */
export enum FeedModuleType {
  /**
   * @generated from enum value: FEED_MODULE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_EDITORIAL_CAROUSEL = 1;
   */
  EDITORIAL_CAROUSEL = 1,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_COLLECTION_SHELF = 2;
   */
  COLLECTION_SHELF = 2,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_PUZZLE_LADDER = 3;
   */
  PUZZLE_LADDER = 3,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_SCHEDULE_WINDOW = 4;
   */
  SCHEDULE_WINDOW = 4,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_LIVE_NOW = 5;
   */
  LIVE_NOW = 5,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_CHAMPIONS_GALLERY = 6;
   */
  CHAMPIONS_GALLERY = 6,

  /**
   * @generated from enum value: FEED_MODULE_TYPE_TRENDING_SHELF = 7;
   */
  TRENDING_SHELF = 7,

  /**
   * the daily opening-trap card (#1152)
   *
   * @generated from enum value: FEED_MODULE_TYPE_DAILY_TRAP = 8;
   */
  DAILY_TRAP = 8,
}

/**
 * Describes the enum chessstreamlive.catalog.v1.FeedModuleType.
 */
export const FeedModuleTypeSchema: GenEnum<FeedModuleType> = /*@__PURE__*/
  enumDesc(file_catalog, 6);

/**
 * @generated from service chessstreamlive.catalog.v1.Catalog
 */
export const Catalog: GenService<{
  /**
   * ── Discovery (home). Anonymous/global; the personalized "For You" arrangement
   *    is an additive user/recs-tier surface that returns this same Feed shape
   *    over refs into these cached bodies (Addendum II/III).
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetFeed
   */
  getFeed: {
    methodKind: "unary";
    input: typeof GetFeedRequestSchema;
    output: typeof FeedSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetCollection
   */
  getCollection: {
    methodKind: "unary";
    input: typeof GetCollectionRequestSchema;
    output: typeof CollectionSchema;
  },
  /**
   * ── Browse.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetSeries
   */
  getSeries: {
    methodKind: "unary";
    input: typeof GetSeriesRequestSchema;
    output: typeof SeriesSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetEdition
   */
  getEdition: {
    methodKind: "unary";
    input: typeof GetEditionRequestSchema;
    output: typeof EditionSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetPlayer
   */
  getPlayer: {
    methodKind: "unary";
    input: typeof GetPlayerRequestSchema;
    output: typeof PlayerSchema;
  },
  /**
   *    `Player.recent_events` is a bounded TEASER (<= 10 in the aggregate build,
   *    <= 8 in the R2 profile bundle), so there is no way to ask for a player's
   *    COMPLETE event history. This is that list, paginated — same EditionRef
   *    cards, oldest history included, one page at a time.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.ListPlayerEvents
   */
  listPlayerEvents: {
    methodKind: "unary";
    input: typeof ListPlayerEventsRequestSchema;
    output: typeof ListPlayerEventsResponseSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetGame
   */
  getGame: {
    methodKind: "unary";
    input: typeof GetGameRequestSchema;
    output: typeof GameSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetHeadToHead
   */
  getHeadToHead: {
    methodKind: "unary";
    input: typeof GetHeadToHeadRequestSchema;
    output: typeof HeadToHeadSchema;
  },
  /**
   * ── Hot path. Static doc + R2 bundle; the VOLATILE bits (review status, live
   *    rating) come from GetLiveStates so these stay cacheable.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetReview
   */
  getReview: {
    methodKind: "unary";
    input: typeof GetReviewRequestSchema;
    output: typeof ReviewSchema;
  },
  /**
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetRatingList
   */
  getRatingList: {
    methodKind: "unary";
    input: typeof GetRatingListRequestSchema;
    output: typeof RatingListSchema;
  },
  /**
   * ── The per-entity VOLATILE channel (live rating / review status; the live
   *    calendar is a SEPARATE volatile surface — ListBroadcasts). POST
   *    (deliberately NOT NO_SIDE_EFFECTS):
   *    viewport id-sets are user-specific (poor cache value) and large viewports
   *    would exceed the ~8 KB GET-URL cap → HTTP 414. The shared volatile data
   *    (live top-list) is cached via GetRatingList. Client MUST viewport-bound
   *    and chunk to ≤ ~50 ids per call.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetLiveStates
   */
  getLiveStates: {
    methodKind: "unary";
    input: typeof GetLiveStatesRequestSchema;
    output: typeof LiveStatesSchema;
  },
  /**
   * ── Puzzle CONTENT only (anonymous packs). Per-user scheduling/recs live in
   *    chess.puzzle.v1.PuzzleService (the future puzzle-service), never here.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetPuzzleSet
   */
  getPuzzleSet: {
    methodKind: "unary";
    input: typeof GetPuzzleSetRequestSchema;
    output: typeof PuzzleSetSchema;
  },
  /**
   * ── Corpus position explorer (opening albums, epic #1001). Given a SAN path
   *    from the start position, returns the ranked continuations played from
   *    that position over the OTB archive with per-move W/D/L, plus every legal
   *    move (so a client can play past the end of the corpus into novelties).
   *    Backed by the shared Fjall move-stats store (the same one that answers
   *    FEN-search novelty). Anonymous, deterministic-by-path → cacheable GET.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetPositionExplorer
   */
  getPositionExplorer: {
    methodKind: "unary";
    input: typeof GetPositionExplorerRequestSchema;
    output: typeof GetPositionExplorerResponseSchema;
  },
  /**
   * ── Daily ladder. The shared, dated, Wordle-style challenge: puzzles in progressive
   *    difficulty, the SAME set for everyone that date, immutable once published.
   *    Anonymous CONTENT only — per-user progress/streaks and the (friendly) leaderboard
   *    are an additive social-tier surface, never here.
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetDailyLadder
   */
  getDailyLadder: {
    methodKind: "unary";
    input: typeof GetDailyLadderRequestSchema;
    output: typeof DailyLadderSchema;
  },
  /**
   * ── Search. Hot, head-heavy, freshness-tolerant → the prime cached GET. The
   *    server normalizes `q` and ranks ANONYMOUSLY; the client surfaces followed
   *    entities from the local bootstrap (no per-user field → no cache-key
   *    fragmentation).
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
  /**
   * ── Tournament detail (PR #520 B2). Read-time merge of the durable
   *    tournament_doc and the volatile overlay; the RESPONSE ENVELOPE carries
   *    the as-of version metadata so the entity blob stays pristine (a fully
   *    published tournament is a byte-for-byte passthrough).
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.GetTournament
   */
  getTournament: {
    methodKind: "unary";
    input: typeof GetTournamentRequestSchema;
    output: typeof GetTournamentResponseSchema;
  },
  /**
   * ── Live broadcasts (calendar). The slow-changing list of streamable
   *    tournaments/rounds, served on the content path so the app never polls the
   *    live relay. Cacheable GET with a SHORT edge TTL (this body IS live-ish:
   *    rounds flip scheduled→streaming→finished within minutes). Per-round live
   *    moves come from the separate Broadcast.Subscribe stream once a user opens
   *    a round. Fed by the control plane via the internal overlay (overlay_push.proto).
   *
   * @generated from rpc chessstreamlive.catalog.v1.Catalog.ListBroadcasts
   */
  listBroadcasts: {
    methodKind: "unary";
    input: typeof ListBroadcastsRequestSchema;
    output: typeof BroadcastListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalog, 0);

